(function(){
var TW2_ASSETS = ((document.currentScript && document.currentScript.src) || '').replace(/twi-mega\.js.*$/, '');
var TW2_HEADS = [
  ['erin-solstice', 'Erin Solstice', 'erin'], ['rags', 'Rags', 'rags'], ['pisces', 'Pisces', 'pisces'],
  ['relc', 'Relc', 'relc'], ['klbkch', 'Klbkch', 'klbkch'], ['mrsha', 'Mrsha', 'mrsha'],
  ['bird', 'Bird', 'bird'], ['pirateaba', 'pirateaba', 'pirateaba']
];
'use strict';
if (!document.documentElement.classList.contains('twi-menu-v2')) return;

var PROFILE = 'refix';   /* flipped 2026-08-09 after the collections re-fix executed: types+tags normalised, 38 collection rules rebuilt. 'current' remains as the rollback path. */

/* component styles ship WITH the JS - atomic, no CSS/JS version skew (noTopline) */
var TW2_STYLE = document.createElement('style');
TW2_STYLE.textContent = `/* ---------------- host visibility (atomic) ----------------
   Ships WITH the JS on purpose: these decide whether the menu renders at all,
   so they must never lag behind in a separately versioned stylesheet. */
/* Dawn's own configured menu links, hidden in favour of ours (setting kept) */
html.twi-menu-v2 .header__inline-menu > ul > li.tw2-hide{ display: none; }

/* ---------------- panel chrome ----------------
   Dawn owns the trigger styling (.header__menu-item), the panel box
   (.mega-menu__content: full header width, square, viewport-capped,
   scroll-safe) and the open/close animation. Nothing here re-implements any
   of that any more — these are CONTENT styles only. */
.tw2-ctas{ display: flex; flex-wrap: wrap; gap: 0.6rem; margin-top: auto; }
.tw2-btn--outline{ background: transparent !important;
  color: rgb(var(--color-button)) !important;
  box-shadow: inset 0 0 0 0.1rem rgb(var(--color-button)); }
.tw2-btn--outline:hover{ background: rgba(var(--color-button), 0.12) !important; }
/* [2026-09-17 a11y] .tw2-posttitle is an <h3> wrapping the link now, so the
   link inherits and the hover moves to the heading. line-height/letter-spacing/
   word-break/font-style/margin are re-stated further down because Dawn's
   h1-h5 rule sets all of them and the anchor never had them. */
.tw2-posttitle > a{ color: inherit; text-decoration: none; display: block; }
.tw2-posttitle:hover{ color: rgb(var(--color-button)); }

/* our panels hold a layout, not Dawn's link grid */
.mega-menu__content > .tw2-flex{ padding-block: 0; }

.tw2-flex{ display: flex; align-items: stretch;
  max-width: var(--page-width, 130rem); margin-inline: auto;
  padding-inline: 5rem; }
@media screen and (max-width: 1279px){ .tw2-flex{ padding-inline: 3rem; } }
/* Dawn hides its inline menu below 990px itself; the drawer takes over */

/* eyebrow */
.tw2-eyebrow{
  font-size: 1.1rem;
  font-weight: var(--font-body-weight-bold, 600);
  letter-spacing: var(--tw2-eyebrow-ls);
  text-transform: uppercase;
  color: rgba(var(--color-button), 0.9);
}

/* buttons (map to Dawn button colours without Dawn's structural classes) */
.tw2-btn{
  display: inline-flex; align-items: center; justify-content: center;
  padding: 0.8rem 1.6rem;
  border: 0; cursor: pointer;
  border-radius: var(--buttons-radius, 4px);
  background: rgb(var(--color-button));
  color: rgb(var(--color-button-text));
  font-family: var(--font-body-family);
  font-size: 1.3rem; font-weight: var(--font-body-weight-bold, 600);
  text-decoration: none;
  transition: filter var(--tw2-t-fast) var(--tw2-ease);
}
.tw2-btn:hover{ filter: brightness(1.08); }
.tw2-btn--outline{
  background: none;
  color: rgb(var(--color-foreground));
  box-shadow: inset 0 0 0 0.1rem rgba(var(--color-foreground), 0.34);
}
.tw2-btn--outline:hover{ color: rgb(var(--color-button)); box-shadow: inset 0 0 0 0.1rem rgba(var(--color-button), 0.7); filter: none; }

/* ---------------- lead column ---------------- */
.tw2-lead{
  flex: none; width: var(--tw2-lead-w);
  display: flex; flex-direction: column;
  margin: var(--tw2-sheet-pad-y) 0 var(--tw2-sheet-pad-y) var(--tw2-sheet-pad-x);
  padding: 0.8rem 1.2rem;
  border-radius: var(--media-radius, 8px);
  background: rgba(var(--color-foreground), 0.035);
  box-shadow: inset 0 0 0 0.1rem rgba(var(--color-foreground), 0.06);
}
.tw2-lead .tw2-eyebrow{ margin-bottom: 1rem; }
/* [2026-09-18 a11y] the lead eyebrow is an h3 now. Cancel what Dawn's h1-h5
   rule and the UA h3 margins add, so it renders exactly like the old span:
   size, weight, spacing, case and colour already come from .tw2-eyebrow. */
.tw2-lead > h3.tw2-eyebrow{ margin: 0 0 1rem; font-family: inherit;
  font-style: inherit; line-height: inherit; word-break: inherit; }
.tw2-lead > a{
  display: block; padding: 0.5rem 0;
  font-size: 1.3rem; text-decoration: none;
  color: rgba(var(--color-foreground), 0.78);
  transition: color var(--tw2-t-fast) var(--tw2-ease);
}
.tw2-lead > a:hover{ color: rgb(var(--color-button)); }
.tw2-lead .tw2-lead-cta{ align-self: flex-start; margin-top: 1rem; padding: 0.6rem 1.2rem; }

/* featured product spotlight at the column foot */
.tw2-spot{ margin-top: auto; padding-top: 1.5rem; }
.tw2-spot-media{
  display: block; width: 100%; height: 184px;
  border-radius: var(--media-radius, 8px);
  overflow: hidden;
  background: rgba(var(--color-foreground), 0.045);
  box-shadow: inset 0 0 0 0.1rem rgba(var(--color-foreground), var(--tw2-frame-a));
  transition: box-shadow var(--tw2-t-fast) var(--tw2-ease);
}
.tw2-spot-media img{ width: 100%; height: 100%; object-fit: cover; display: block; }
.tw2-spot:hover .tw2-spot-media{ box-shadow: inset 0 0 0 0.1rem rgba(var(--color-button), 0.55); }
.tw2-spot .tw2-eyebrow{ display: block; margin: 0.8rem 0 0.2rem; }
.tw2-spot-name{
  display: block; text-decoration: none;
  font-family: var(--font-heading-family);
  font-weight: var(--font-heading-weight);
  font-size: 1.3rem; line-height: 1.3;
  color: rgba(var(--color-foreground), 0.92);
}
.tw2-spot:hover .tw2-spot-name{ color: rgb(var(--color-button)); }
.tw2-spot-price{ display: block; font-size: 1.2rem; color: rgba(var(--color-foreground), var(--tw2-muted-a)); margin-top: 0.1rem; }
.tw2-spot .tw2-btn{ margin-top: 0.8rem; padding: 0.6rem 1.4rem; }

/* ---------------- BENTO: uniform card grid, all sheets one size ----------
   Every cell is the same card grammar (image block, kicker, title, links);
   featuring = the one wider cell with a taller image. Sheets share a fixed
   content height so Books/Shop/Collections feel like one system. */
/* FIXED sheet height — identical for all three menus; no content can
   inflate it (the tall Book One art blew the sheet to ~900px when the
   featured media sized from image intrinsics) */
.tw2-flex{ height: 432px; min-height: 0; }
.tw2-depts{
  flex: 1 1 auto; min-width: 0;
  display: grid; column-gap: 0.8rem;
  align-items: stretch;
  padding: var(--tw2-sheet-pad-y) var(--tw2-sheet-pad-x);
}
.tw2-dept{
  min-width: 0; display: flex; flex-direction: column; align-items: flex-start;
  padding: 0.8rem;
  border-radius: var(--media-radius, 8px);
  background: rgba(var(--color-foreground), 0.035);
  box-shadow: inset 0 0 0 0.1rem rgba(var(--color-foreground), 0.06);
  transition: box-shadow var(--tw2-t-fast) var(--tw2-ease), background var(--tw2-t-fast) var(--tw2-ease);
}
.tw2-dept:hover{
  background: rgba(var(--color-foreground), 0.055);
  box-shadow: inset 0 0 0 0.1rem rgba(var(--color-button), 0.3);
}
.tw2-dept-media{
  display: block; width: 100%; height: 110px;
  border-radius: calc(var(--media-radius, 8px) - 3px);
  overflow: hidden;
  background: rgba(var(--color-foreground), 0.045);
}
.tw2-dept-media img{ width: 100%; height: 100%; object-fit: cover; display: block; }
/* featured media GROWS to absorb slack — but as an absolute fill so image
   intrinsics can NEVER inflate the layout (root cause of the 900px sheet) */
.tw2-dept--featured{ min-height: 0; height: 100%; }
.tw2-dept--featured .tw2-dept-media{
  position: relative;
  flex: 1 1 0; height: auto; min-height: 140px;
}
.tw2-dept--featured .tw2-dept-media img{
  position: absolute; inset: 0; width: 100%; height: 100%;
}

/* Collections: two-row poster mosaic (bento-lab pattern A winner) */
.tw2-postgrid{
  flex: 1 1 auto; min-width: 0;
  display: grid; gap: 0.8rem;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 1fr;
  padding: var(--tw2-sheet-pad-y) var(--tw2-sheet-pad-x);
}
.tw2-postcard{
  position: relative; overflow: hidden;
  border-radius: var(--media-radius, 8px);
  background: rgba(var(--color-foreground), 0.035);
  box-shadow: inset 0 0 0 0.1rem rgba(var(--color-foreground), 0.06);
  display: flex; flex-direction: column;
  min-height: 150px;
  text-decoration: none;
  transition: box-shadow var(--tw2-t-fast) var(--tw2-ease);
}
.tw2-postcard:hover{ box-shadow: inset 0 0 0 0.1rem rgba(var(--color-button), 0.35); }
.tw2-postcard img{ position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
.tw2-postcard .tw2-postfoot{
  position: relative; margin-top: auto;
  padding: 0.6rem 1rem 0.7rem;
  background: rgba(var(--color-background), 0.9);
  border-top: 0.1rem solid rgba(var(--color-foreground), 0.07);
}
.tw2-postcard .tw2-posttitle{
  display: block;
  /* it is an <h3> now: cancel the four Dawn h1-h5 declarations the old <a>
     never had, so the poster footers render exactly as before */
  margin: 0; line-height: inherit; letter-spacing: normal; word-break: normal;
  font-family: var(--font-heading-family);
  font-style: var(--font-body-style);
  font-weight: var(--font-heading-weight);
  font-size: 1.45rem;
  color: rgb(var(--color-foreground));
}
.tw2-postbg{ position: absolute; inset: 0; display: block; }
.tw2-postbg img{ width: 100%; height: 100%; object-fit: cover; display: block; }
.tw2-postcard > img, .tw2-mband > img{ position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
/* compact inline sub-links inside the footer — poster look, findability kept */
.tw2-postlinks{ display: flex; flex-wrap: wrap; gap: 0 1.1rem; margin-top: 0.2rem; }
.tw2-postlinks a{
  font-size: 1.15rem; line-height: 1.7;
  color: rgba(var(--color-foreground), 0.62);
  text-decoration: none;
  transition: color var(--tw2-t-fast) var(--tw2-ease);
}
.tw2-postlinks a:hover{ color: rgb(var(--color-button)); }
.tw2-kicker{ min-height: var(--tw2-kicker-h); display: flex; align-items: flex-end; margin-top: 1rem; max-width: 100%; }
.tw2-kicker .tw2-eyebrow{ white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.tw2-badge{
  display: inline-block; padding: 0.3rem 0.7rem;
  background: rgb(var(--color-badge-background, var(--color-button)));
  color: rgb(var(--color-badge-foreground, var(--color-button-text)));
  border-radius: var(--badge-corner-radius, 0.2rem);
  font-size: 1.05rem; font-weight: var(--font-body-weight-bold, 600);
  letter-spacing: var(--tw2-eyebrow-ls); text-transform: uppercase;
  white-space: nowrap;
}
/* 2.5.8 Target Size (AA): these were 20px tall with a 4px gap, so the
   spacing exception did not rescue them — give every title a 24px target. */
.tw2-title{ min-height: 24px; display: flex; align-items: center;

  margin: 0.4rem 0 0.8rem;
  font-family: var(--font-heading-family);
  font-weight: var(--font-heading-weight);
  font-size: 1.7rem; line-height: 1.2; letter-spacing: 0.01em;
  color: rgb(var(--color-foreground));
  text-decoration: none; display: inline-block;
  transition: color var(--tw2-t-fast) var(--tw2-ease);
  /* [2026-09-17 a11y] .tw2-title is an <h3> wrapping the link now. Everything
     above already beats Dawn's h1-h5 rule; these two are the only declarations
     in it that this class did not already restate. */
  font-style: var(--font-body-style); word-break: normal;
}
/* the LINK is still the 24px target (2.5.8 above) — it is a block child so the
   heading box stays exactly 24px and no inline strut creeps in */
.tw2-title > a{ display: block; min-height: 24px; color: inherit; text-decoration: none; }
.tw2-title:hover{ color: rgb(var(--color-button)); }
.tw2-meta{ font-size: 1.3rem; color: rgba(var(--color-foreground), var(--tw2-muted-a)); margin: -0.4rem 0 0.8rem; }
.tw2-links{ list-style: none; margin: 0; padding: 0; width: 100%; }
.tw2-links a{
  display: block; padding: 0.3rem 0; text-decoration: none;
  font-size: 1.3rem; line-height: 1.5;
  color: rgba(var(--color-foreground), 0.74);
  transition: color var(--tw2-t-fast) var(--tw2-ease), padding-left var(--tw2-t-fast) var(--tw2-ease);
}
.tw2-links a:hover{ color: rgb(var(--color-button)); padding-left: 0.3rem; }
.tw2-dept .tw2-btn{ margin-top: 0.8rem; padding: 0.6rem 1.4rem; }

/* mini product thumbs (opt-in per dept) */
.tw2-thumbs{ width: 100%; margin-top: 1rem; }
.tw2-thumbs .tw2-eyebrow{ display: block; margin-bottom: 0.5rem; font-size: 1rem; }
.tw2-thumbs-row{ display: flex; gap: 0.5rem; }
.tw2-thumbs-row a{
  display: block; width: 48px; height: 48px;
  border-radius: calc(var(--media-radius, 8px) / 2);
  overflow: hidden;
  box-shadow: inset 0 0 0 0.1rem rgba(var(--color-foreground), var(--tw2-frame-a));
  transition: box-shadow var(--tw2-t-fast) var(--tw2-ease), transform var(--tw2-t-fast) var(--tw2-ease);
}
.tw2-thumbs-row img{ width: 100%; height: 100%; object-fit: cover; display: block; }
.tw2-thumbs-row a:hover{ transform: translateY(-1px); box-shadow: inset 0 0 0 0.1rem rgba(var(--color-button), 0.55); }

/* ---------------- Books: expanding series + volumes band ---------------- */
.tw2-bkwrap{ flex: 1 1 auto; min-width: 0; padding: var(--tw2-sheet-pad-y) var(--tw2-sheet-pad-x); }
.tw2-bkcols{ display: flex; align-items: flex-start; }
.tw2-bkcol{
  min-width: 0; flex: 1 1 0%;
  display: flex; flex-direction: column; align-items: flex-start;
  transition: flex-grow var(--tw2-t-menu) var(--tw2-ease);
}
.tw2-bkcol + .tw2-bkcol{ margin-left: var(--tw2-dept-gap-x); }
.tw2-bkcol.tw2-open{ flex-grow: 1.9; }
.tw2-tile{
  display: block; width: 100%; text-decoration: none;
  border-radius: var(--media-radius, 8px);
  overflow: hidden;
  background: rgba(var(--color-foreground), 0.045);
  box-shadow: inset 0 0 0 0.1rem rgba(var(--color-foreground), var(--tw2-frame-a));
  transition: box-shadow var(--tw2-t-fast) var(--tw2-ease);
}
.tw2-tile:hover{ box-shadow: inset 0 0 0 0.1rem rgba(var(--color-button), 0.55); }
.tw2-tile img{ width: 100%; height: auto; aspect-ratio: 2 / 3; object-fit: cover; display: block; }
.tw2-tile-name{
  min-height: 48px;
  display: flex; align-items: center;
  padding: 0.5rem 1rem;
  border-top: 0.1rem solid rgba(var(--color-foreground), var(--tw2-hairline-faint-a));
  font-family: var(--font-heading-family);
  font-weight: var(--font-heading-weight);
  font-size: 1.6rem; line-height: 1.2;
  color: rgba(var(--color-foreground), 0.94);
}
.tw2-bkcol.tw2-open .tw2-tile{ display: none; }
.tw2-bkx{ display: none; }
.tw2-bkcol.tw2-open .tw2-bkx{
  display: flex; gap: 1.5rem; align-items: flex-start;
  animation: tw2fade var(--tw2-t-menu) var(--tw2-ease);
}
@keyframes tw2fade{ from{ opacity: 0; } to{ opacity: 1; } }
.tw2-bkx-cover{
  display: block; flex: none;
  height: var(--tw2-cover-h); aspect-ratio: 2 / 3;
  border-radius: calc(var(--media-radius, 8px) / 2);
  overflow: hidden;
  box-shadow: 0 10px 22px -8px rgba(var(--color-shadow, 0,0,0), 0.7),
    inset 0 0 0 0.1rem rgba(var(--color-foreground), var(--tw2-frame-a));
}
.tw2-bkx-cover img{ width: 100%; height: 100%; object-fit: cover; display: block; }
.tw2-bkx-body{ min-width: 0; }
.tw2-bkcol .tw2-btn{ opacity: 0; pointer-events: none; transition: opacity var(--tw2-t-menu) var(--tw2-ease); margin-top: 0.8rem; padding: 0.6rem 1.4rem; }
.tw2-bkcol.tw2-open .tw2-btn{ opacity: 1; pointer-events: auto; }

.tw2-band{
  position: relative;
  margin-top: 1.5rem; padding-top: 1rem;
  border-top: 0.1rem solid rgba(var(--color-foreground), var(--tw2-hairline-faint-a));
  min-height: 150px;
}
.tw2-band-pane{
  position: absolute; inset: 1rem 0 0 0;
  opacity: 0; visibility: hidden;
  transition: opacity var(--tw2-t-menu) var(--tw2-ease), visibility 0s linear var(--tw2-t-menu);
}
.tw2-band-pane.tw2-active{
  opacity: 1; visibility: visible;
  transition: opacity var(--tw2-t-menu) var(--tw2-ease), visibility 0s;
}
.tw2-band-pane .tw2-eyebrow{ display: block; margin-bottom: 0.5rem; font-size: 1rem; }
.tw2-band-row{
  display: flex; gap: 0.5rem;
  overflow-x: auto; overflow-y: hidden;
  scrollbar-width: none;
  -webkit-mask-image: linear-gradient(90deg, #000 92%, transparent 100%);
  mask-image: linear-gradient(90deg, #000 92%, transparent 100%);
  padding-bottom: 2px;
}
.tw2-band-row::-webkit-scrollbar{ display: none; }
.tw2-band-row a{
  flex: none; display: block; width: 64px;
  border-radius: calc(var(--media-radius, 8px) / 2);
  overflow: hidden;
  box-shadow: inset 0 0 0 0.1rem rgba(var(--color-foreground), var(--tw2-frame-a));
  transition: transform var(--tw2-t-fast) var(--tw2-ease), box-shadow var(--tw2-t-fast) var(--tw2-ease);
}
.tw2-band-row img{ width: 64px; aspect-ratio: 2 / 3; object-fit: cover; display: block; }
.tw2-band-row a:hover{ transform: translateY(-2px); box-shadow: inset 0 0 0 0.1rem rgba(var(--color-button), 0.55); }
.tw2-band-arrow{
  position: absolute; top: 50%; margin-top: 4px; transform: translateY(-50%);
  width: 32px; height: 32px; border: 0; cursor: pointer;
  display: none; align-items: center; justify-content: center;
  border-radius: 50%;
  background: rgb(var(--color-background));
  box-shadow: inset 0 0 0 0.1rem rgba(var(--color-foreground), 0.25),
    0 2px 10px rgba(var(--color-shadow, 0,0,0), 0.5);
  color: rgba(var(--color-foreground), 0.85);
  z-index: 2;
  transition: color var(--tw2-t-fast) var(--tw2-ease), opacity var(--tw2-t-fast) var(--tw2-ease);
}
.tw2-band-arrow svg{ width: 14px; height: 14px; }
.tw2-band-arrow:hover{ color: rgb(var(--color-button)); }
.tw2-band-arrow--prev{ left: -8px; }
.tw2-band-arrow--next{ right: -8px; }
.tw2-band-pane.tw2-overflow .tw2-band-arrow{ display: flex; }
.tw2-band-arrow[disabled]{ opacity: 0.25; pointer-events: none; }
.tw2-band-pane.tw2-overflow .tw2-band-row{
  -webkit-mask-image: linear-gradient(90deg, transparent 0, #000 4%, #000 92%, transparent 100%);
  mask-image: linear-gradient(90deg, transparent 0, #000 4%, #000 92%, transparent 100%);
}
.tw2-band-pane.tw2-overflow.tw2-at-start .tw2-band-row{
  -webkit-mask-image: linear-gradient(90deg, #000 92%, transparent 100%);
  mask-image: linear-gradient(90deg, #000 92%, transparent 100%);
}
.tw2-band-pane.tw2-overflow.tw2-at-end .tw2-band-row{
  -webkit-mask-image: linear-gradient(90deg, transparent 0, #000 4%, #000 100%);
  mask-image: linear-gradient(90deg, transparent 0, #000 4%, #000 100%);
}

/* ---------------- mobile: burger + drawer ---------------- */

html.twi-menu-v2 .tw2-burger{ display: none; }
@media screen and (max-width: 989px){
  html.twi-menu-v2 .tw2-nav{ display: none; }
  html.twi-menu-v2 .tw2-burger{
    display: inline-flex; align-items: center; justify-content: center;
    width: 4.4rem; height: 4.4rem;
    background: none; border: 0; cursor: pointer;
    color: rgb(var(--color-foreground));
    justify-self: start; margin-left: -1.2rem;
  }
  html.twi-menu-v2 .tw2-burger svg{ width: 2.2rem; height: 2.2rem; }
}
html.twi-menu-v2 .tw2-scrim{
  display: block;
  position: fixed; inset: 0; z-index: 20;
  background: rgba(var(--color-shadow, 0,0,0), var(--tw2-veil-a));
  opacity: 0; visibility: hidden;
  transition: opacity var(--tw2-t-menu) var(--tw2-ease), visibility 0s linear var(--tw2-t-menu);
}
html.twi-menu-v2.tw2-drawer-open .tw2-scrim{ opacity: 1; visibility: visible; transition: opacity var(--tw2-t-menu) var(--tw2-ease), visibility 0s; }
/* mobile v2: FULL-SCREEN menu (big-store pattern), not a narrow drawer */
html.twi-menu-v2 .tw2-drawer{
  display: flex; flex-direction: column;
  position: fixed; inset: 0; z-index: 21;
  width: 100vw;
  background: rgb(var(--color-background));
  transform: translateX(-102%);
  transition: transform 320ms cubic-bezier(0.32, 0.72, 0.28, 1);
  overflow: hidden; overscroll-behavior: contain;
}

/* department tabs */
.tw2-mtabs{
  display: flex; flex: none;
  margin: 1rem 1.6rem 0;
  border-bottom: 0.1rem solid rgba(var(--color-foreground), var(--tw2-hairline-faint-a));
}
.tw2-mtabs button{
  flex: 1 1 0; padding: 1.1rem 0.5rem;
  background: none; border: 0; cursor: pointer;
  font-family: var(--font-heading-family);
  font-weight: var(--font-heading-weight);
  font-size: 1.6rem;
  color: rgba(var(--color-foreground), 0.6);
  border-bottom: 2px solid transparent;
}
.tw2-mtabs .tw2-mtab-on{
  color: rgb(var(--color-foreground));
  border-bottom-color: rgb(var(--color-button));
}

/* tab panes — the scroll region */
.tw2-mpanes{ flex: 1 1 auto; overflow-y: auto; padding: 1.2rem 1.6rem 9rem; }
.tw2-mpane{ display: none; }
.tw2-mpane-on{ display: block; }
.tw2-mchips{ display: flex; flex-wrap: wrap; gap: 0.6rem; margin-bottom: 1.2rem; }
.tw2-mchips a{
  padding: 0.7rem 1.2rem;
  border-radius: 99px;
  background: rgba(var(--color-foreground), 0.05);
  box-shadow: inset 0 0 0 0.1rem rgba(var(--color-foreground), 0.1);
  font-size: 1.25rem; font-weight: var(--font-body-weight-bold, 600);
  color: rgba(var(--color-foreground), 0.85);
  text-decoration: none;
}

/* image-band category rows — mobile poster grammar */
.tw2-mband{
  position: relative; display: flex; flex-direction: column;
  min-height: 104px;
  border-radius: var(--media-radius, 8px);
  overflow: hidden;
  margin-bottom: 0.8rem;
  background: rgba(var(--color-foreground), 0.035);
  text-decoration: none;
}
.tw2-mband--feat{ min-height: 168px; }
.tw2-mband img{ position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
.tw2-mband-foot{
  position: relative; margin-top: auto;
  padding: 0.6rem 1.2rem 0.8rem;
  background: rgba(var(--color-background), 0.9);
  border-top: 0.1rem solid rgba(var(--color-foreground), 0.07);
}
.tw2-mband-foot .tw2-badge{ position: absolute; top: -3.2rem; left: 1.2rem; }
.tw2-mband-foot .tw2-posttitle{ font-size: 1.6rem; }
.tw2-mband-foot .tw2-postlinks a{ font-size: 1.25rem; line-height: 2; }

/* fixed app-style bottom bar */
.tw2-mbar{
  position: absolute; left: 0; right: 0; bottom: 0;
  display: grid; grid-template-columns: repeat(4, 1fr);
  background: rgb(var(--color-background));
  border-top: 0.1rem solid rgba(var(--color-foreground), 0.1);
  padding: 0.7rem 0 calc(0.7rem + env(safe-area-inset-bottom, 0px));
}
.tw2-mbar a{
  position: relative;
  display: flex; flex-direction: column; align-items: center; gap: 0.3rem;
  font-size: 1.1rem; color: rgba(var(--color-foreground), 0.8);
  text-decoration: none;
}
.tw2-mbar svg{ width: 2rem; height: 2rem; }
.tw2-mbar .tw2-dbubble{ position: absolute; top: -0.4rem; right: calc(50% - 2.1rem); min-width: 1.6rem; height: 1.6rem; padding: 0 0.4rem; display: flex; align-items: center; justify-content: center; background: rgb(var(--color-button)); color: rgb(var(--color-button-text)); font-size: 1rem; font-weight: 700; border-radius: 99px; }
html.twi-menu-v2.tw2-drawer-open .tw2-drawer{ transform: none; }
html.twi-menu-v2.tw2-drawer-open{ overflow: hidden; }
.tw2-drawer-head{
  display: flex; align-items: center; justify-content: space-between;
  padding: 1.2rem 1.6rem;
  border-bottom: 0.1rem solid rgba(var(--color-foreground), var(--tw2-hairline-faint-a));
}
.tw2-drawer-head img{ height: 4.4rem; width: auto; }
.tw2-drawer-close{ background: none; border: 0; cursor: pointer; color: rgb(var(--color-foreground)); padding: 1rem; }
.tw2-drawer-close svg{ width: 2rem; height: 2rem; }
.tw2-dsearch{
  display: flex; align-items: center; gap: 0.6rem;
  margin: 1.2rem 1.6rem 0; padding: 0 1rem;
  background: rgba(var(--color-foreground), 0.045);
  border: 0.1rem solid rgba(var(--color-foreground), var(--tw2-hairline-a));
  border-radius: var(--inputs-radius, 4px);
}
.tw2-dsearch svg{ flex: none; width: 1.8rem; height: 1.8rem; color: rgba(var(--color-foreground), var(--tw2-faint-a)); }
.tw2-dsearch input{
  flex: 1 1 auto; min-width: 0; height: 4.4rem;
  background: none; border: 0; outline: none;
  color: rgb(var(--color-foreground));
  font-size: 1.5rem; font-family: var(--font-body-family);
}
.tw2-dquick{
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 0.6rem;
  margin: 1.2rem 1.6rem 0;
}
.tw2-dquick a{
  display: flex; align-items: center; justify-content: center;
  min-height: 4.4rem; padding: 0.5rem; text-align: center; text-decoration: none;
  border-radius: var(--media-radius, 8px);
  background: rgba(var(--color-foreground), 0.045);
  box-shadow: inset 0 0 0 0.1rem rgba(var(--color-foreground), var(--tw2-frame-a));
  font-size: 1.3rem; font-weight: var(--font-body-weight-bold, 600);
  color: rgba(var(--color-foreground), 0.9);
}
.tw2-dpromo{
  display: flex; gap: 1.2rem; align-items: center; text-decoration: none;
  margin: 1.2rem 1.6rem 0.4rem;
  padding: 1rem;
  background: rgba(var(--color-button), 0.07);
  border: 0.1rem solid rgba(var(--color-button), 0.34);
  border-radius: var(--popup-corner-radius, 10px);
}
.tw2-dpromo img{
  flex: none; width: 56px; aspect-ratio: 2/3; object-fit: cover;
  border-radius: calc(var(--media-radius, 8px) / 2);
}
.tw2-dpromo-body{ min-width: 0; }
.tw2-dpromo-title{
  display: block; margin-top: 0.4rem;
  font-family: var(--font-heading-family); font-weight: var(--font-heading-weight);
  font-size: 1.4rem; line-height: 1.3; color: rgb(var(--color-foreground));
}
.tw2-dpromo-meta{ display: block; font-size: 1.2rem; color: rgba(var(--color-foreground), var(--tw2-muted-a)); }
.tw2-dpromo-cta{ display: block; margin-top: 0.3rem; font-size: 1.3rem; font-weight: var(--font-body-weight-bold, 600); color: rgb(var(--color-button)); }
.tw2-dnav{ padding: 0.6rem 0 1rem; }
.tw2-acc{ border-bottom: 0.1rem solid rgba(var(--color-foreground), var(--tw2-hairline-faint-a)); }
.tw2-acc-head{
  width: 100%; display: flex; align-items: center; justify-content: space-between;
  padding: 1.4rem 1.6rem; background: none; border: 0; cursor: pointer;
  font-family: var(--font-heading-family); font-weight: var(--font-heading-weight);
  font-size: 1.7rem; color: rgb(var(--color-foreground));
}
.tw2-acc-head svg{ width: 1.4rem; height: 1.4rem; color: rgba(var(--color-foreground), var(--tw2-faint-a)); transition: transform var(--tw2-t-menu) var(--tw2-ease); }
.tw2-acc-head[aria-expanded="true"]{ color: rgb(var(--color-button)); }
.tw2-acc-head[aria-expanded="true"] svg{ transform: rotate(180deg); color: currentColor; }
.tw2-acc-body{ display: grid; grid-template-rows: 0fr; transition: grid-template-rows var(--tw2-t-menu) var(--tw2-ease); }
.tw2-acc-body.tw2-open{ grid-template-rows: 1fr; }
.tw2-acc-body > div{ overflow: hidden; min-height: 0; }
.tw2-acc-inner{ padding: 0 1.6rem 1.2rem; }
.tw2-dlink{
  display: block; padding: 0.7rem 0; text-decoration: none;
  font-size: 1.5rem; color: rgba(var(--color-foreground), var(--tw2-muted-a));
}
.tw2-dlink--all{ color: rgba(var(--color-button), 0.9); }
.tw2-dseries{ display: flex; gap: 1.2rem; align-items: flex-start; padding: 0.5rem 0; text-decoration: none; }
.tw2-dseries img{ flex: none; width: 40px; aspect-ratio: 2/3; object-fit: cover; border-radius: 3px; }
.tw2-dseries-name{
  display: block;
  font-family: var(--font-heading-family); font-weight: var(--font-heading-weight);
  font-size: 1.4rem; color: rgba(var(--color-foreground), 0.92);
}
.tw2-dseries-links{ display: flex; flex-wrap: wrap; gap: 0 1rem; }
.tw2-dseries-links a{ font-size: 1.2rem; color: rgba(var(--color-foreground), 0.7); text-decoration: none; padding: 0.2rem 0; }
.tw2-dcat summary{ list-style: none; display: flex; align-items: center; gap: 1rem; padding: 0.6rem 0; cursor: pointer; font-size: 1.5rem; font-weight: var(--font-body-weight-bold, 600); color: rgba(var(--color-foreground), 0.92); }
.tw2-dcat summary::-webkit-details-marker{ display: none; }
.tw2-dcat summary img{ width: 42px; height: 42px; object-fit: cover; border-radius: 4px; }
.tw2-dcat summary svg{ margin-left: auto; width: 1.3rem; height: 1.3rem; color: rgba(var(--color-foreground), var(--tw2-faint-a)); transition: transform var(--tw2-t-fast) var(--tw2-ease); }
.tw2-dcat[open] summary{ color: rgb(var(--color-button)); }
.tw2-dcat[open] summary svg{ transform: rotate(180deg); }
.tw2-dcat-body{ padding-left: 5.4rem; padding-bottom: 0.6rem; }
.tw2-dutil{ border-top: 0.1rem solid rgba(var(--color-foreground), var(--tw2-hairline-faint-a)); padding: 1.2rem 1.6rem 1.6rem; }
.tw2-dtiles{ display: grid; grid-template-columns: repeat(3, 1fr); gap: 0.6rem; margin-bottom: 1rem; }
.tw2-dtiles a{
  position: relative;
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 0.4rem;
  min-height: 6.4rem; text-decoration: none;
  border-radius: var(--media-radius, 8px);
  background: rgba(var(--color-foreground), 0.045);
  box-shadow: inset 0 0 0 0.1rem rgba(var(--color-foreground), var(--tw2-frame-a));
  font-size: 1.2rem; color: rgba(var(--color-foreground), 0.85);
}
.tw2-dtiles svg{ width: 2rem; height: 2rem; }
.tw2-dtiles .tw2-dbubble{
  position: absolute; top: 0.8rem; right: calc(50% - 2.2rem);
  min-width: 1.7rem; height: 1.7rem; padding: 0 0.4rem;
  display: flex; align-items: center; justify-content: center;
  background: rgb(var(--color-button)); color: rgb(var(--color-button-text));
  font-size: 1.1rem; font-weight: 700; border-radius: 99px;
}
.tw2-drow{
  width: 100%; display: flex; align-items: center; gap: 1rem;
  padding: 0.8rem 0; background: none; border: 0; cursor: pointer; text-align: left;
  font-size: 1.4rem; color: rgba(var(--color-foreground), var(--tw2-muted-a));
}
.tw2-drow svg{ width: 1.8rem; height: 1.8rem; }
.tw2-dsocial{ display: flex; flex-wrap: wrap; gap: 1.4rem; margin-top: 0.8rem; }
.tw2-dsocial a{ font-size: 1.1rem; letter-spacing: 0.08em; text-transform: uppercase; text-decoration: none; color: rgba(var(--color-foreground), var(--tw2-faint-a)); }
.tw2-dsocial a:hover{ color: rgb(var(--color-button)); }

/* responsive sheet tweaks */
@media screen and (max-width: 1279px){
  :root{ --tw2-lead-w: 176px; --tw2-cover-h: 190px; }
}

.tw2c{ --tw2c-ink: rgb(var(--color-foreground)); --tw2c-muted: rgba(var(--color-foreground), 0.62);
  --tw2c-line: rgba(var(--color-foreground), 0.12); --tw2c-gold: rgb(var(--color-button));
  --tw2c-row: rgba(var(--color-foreground), 0.06); --tw2c-imgbg: rgba(var(--color-foreground), 0.045);
  font-family: var(--font-body-family); color: var(--tw2c-ink); }
.tw2c a{ color: inherit; text-decoration: none; }
/* one grid */
.tw2c-pg{ display: grid; grid-template-columns: 232px minmax(0, 1fr); column-gap: 40px;
  max-width: var(--page-width, 130rem); margin-inline: auto; padding: 32px 5rem; }
@media screen and (max-width: 1279px){ .tw2c-pg{ padding-inline: 3rem; } }
.tw2c-strip{ display: flex; align-items: center; justify-content: flex-end; min-height: 52px;
  max-width: var(--page-width, 130rem); margin-inline: auto; padding: 0 5rem;
  border-top: 1px solid var(--tw2c-line); }
@media screen and (max-width: 1279px){ .tw2c-strip{ padding-inline: 3rem; } }
/* one type scale: 22 / 16 / 14 / 12. Headings reset Dawn's h-rules. */
.tw2c h3{ margin: 0; letter-spacing: normal; word-break: normal; font-style: normal; }
.tw2c-h1{ font-family: var(--font-heading-family); font-weight: 700; font-size: 2.2rem; line-height: 1.25; margin: 0 0 8px !important; }
.tw2c-h1 > a{ display: block; min-height: 24px; }
.tw2c-h1 > a:hover{ color: var(--tw2c-gold); }
.tw2c-h2{ font-family: var(--font-heading-family); font-weight: 700; font-size: 1.6rem; line-height: 1.3; min-height: 24px; margin: 0 0 16px !important; }
.tw2c-nm{ display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
  font-size: 1.4rem; font-weight: 600; line-height: 1.35; }
.tw2c-meta{ display: block; font-size: 1.2rem; line-height: 1.4; color: var(--tw2c-muted); }
.tw2c-lede{ font-size: 1.4rem; line-height: 1.5; margin: 0 0 16px; max-width: 52ch; }
.tw2c-more{ display: inline-flex; align-items: center; gap: 0.5rem; min-height: 24px; white-space: nowrap;
  font-size: 1.4rem; font-weight: 600; color: var(--tw2c-gold) !important; }
.tw2c-more:hover{ text-decoration: underline !important; }
.tw2c-col1{ display: flex; flex-direction: column; }
.tw2c-heads{ display: grid; grid-template-columns: repeat(4, 40px); justify-content: space-between; row-gap: 10px;
  list-style: none; margin: auto 0 0; padding: 16px 0 0; border: 0; }
.tw2c-heads a{ display: block; width: 40px; height: 40px; border-radius: 50%; overflow: hidden;
  background: var(--tw2c-imgbg); box-shadow: 0 0 0 1px var(--tw2c-line); transition: box-shadow .15s, transform .15s; }
.tw2c-heads a:hover, .tw2c-heads a:focus-visible{ box-shadow: 0 0 0 2px var(--tw2c-gold); transform: translateY(-1px); }
.tw2c-heads img{ display: block; width: 100%; height: 100%; }
/* buttons: square, like the live theme */
.tw2c-ctas{ display: flex; gap: 8px; flex-wrap: wrap; margin: 0 0 16px; }
.tw2c-bt{ display: inline-flex; align-items: center; min-height: 40px; padding: 0 16px;
  border: 1px solid var(--tw2c-line); border-radius: var(--buttons-radius, 0);
  font-size: 1.4rem; font-weight: 700; }
.tw2c-bt:hover{ border-color: var(--tw2c-ink); }
.tw2c-bt--pri{ background: var(--tw2c-gold); color: rgb(var(--color-button-text)) !important; border-color: var(--tw2c-gold); }
.tw2c-bt--pri:hover{ filter: brightness(1.08); border-color: var(--tw2c-gold); }
/* rail row (left-column collection list) */
.tw2c-rail{ list-style: none; margin: 0 0 0 -12px; padding: 0; }
.tw2c-rr{ display: grid; grid-template-columns: 40px 1fr; gap: 12px; align-items: center; min-height: 48px; padding: 4px 12px; }
.tw2c-ld{ width: 40px; height: 40px; overflow: hidden; background: var(--tw2c-imgbg); }
.tw2c-ld img{ width: 40px; height: 40px; object-fit: cover; display: block; }
.tw2c-rr:hover, .tw2c-rr[aria-current]{ background: var(--tw2c-row); }
.tw2c-rr:hover .tw2c-nm, .tw2c-rr[aria-current] .tw2c-nm{ color: var(--tw2c-gold); }
.tw2c-rr .tw2c-nm{ -webkit-line-clamp: 2; }
/* mini row */
.tw2c-mrs, .tw2c-mrl{ list-style: none; margin: 0; padding: 0; }
.tw2c-mrs{ border-top: 1px solid var(--tw2c-line); padding-top: 8px; }
.tw2c-mr{ display: grid; grid-template-columns: 56px 1fr; gap: 12px; align-items: center; min-height: 68px; padding: 6px 0; }
.tw2c-th{ width: 56px; height: 56px; overflow: hidden; background: var(--tw2c-imgbg); }
.tw2c-th img{ width: 100%; height: 100%; object-fit: cover; display: block; }
.tw2c-mr:hover .tw2c-nm{ color: var(--tw2c-gold); }
.tw2c-ml{ display: flex; align-items: baseline; gap: 8px; font-size: 1.4rem; margin-top: 2px; }
.tw2c-ml s{ color: var(--tw2c-muted); font-size: 1.2rem; }
.tw2c-rt{ font-size: 1.2rem; color: var(--tw2c-muted); white-space: nowrap; }
.tw2c-st{ color: var(--tw2c-gold); }
/* lookbook feature: 360 / 176 / text */
.tw2c-feat{ display: grid; grid-template-columns: 360px 176px minmax(0, 1fr); gap: 16px; }
.tw2c-feat--2{ grid-template-columns: 360px 176px minmax(0, 1fr); }
.tw2c-feat--1{ grid-template-columns: 360px minmax(0, 1fr); }
.tw2c-feat--0{ grid-template-columns: minmax(0, 1fr); }
.tw2c-lb{ display: block; position: relative; overflow: hidden; background: var(--tw2c-imgbg); }
.tw2c-lb img{ position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; display: block; transition: transform 0.3s ease; }
.tw2c-lb:hover img{ transform: scale(1.03); }
@media (prefers-reduced-motion: reduce){ .tw2c-lb img{ transition: none; } .tw2c-lb:hover img{ transform: none; } }
.tw2c-lb--big{ height: 420px; }
.tw2c-lbs{ display: grid; grid-template-rows: 1fr 1fr; gap: 16px; height: 420px; }
.tw2c-lb--prod{ background: #fff; }
.tw2c-lb--prod img{ object-fit: contain; }
.tw2c-ftx{ min-width: 0; padding-left: 24px; }
/* gift finder columns */
.tw2c-g{ display: grid; gap: 0 40px; }
.tw2c-gcol{ min-width: 0; position: relative; }
.tw2c-gcol + .tw2c-gcol::before{ content: ''; position: absolute; top: 0; bottom: 0; left: -20px;
  border-left: 1px solid var(--tw2c-line); }
.tw2c-gcol .tw2c-more{ margin-top: 8px; }

.tw2c-ls{ list-style: none; margin: 0; padding: 0; }
.tw2c-ls a{ display: block; padding: 5px 0; font-size: 1.4rem; line-height: 2rem; }
.tw2c-ls a:hover{ color: var(--tw2c-gold); }
.tw2c-ls--muted a{ color: var(--tw2c-muted); }
/* the lead link (the one pointing at Best Sellers): gold, plus weight so it is not colour alone */
.tw2c-ls a.tw2c-lead{ color: var(--tw2c-gold); font-weight: 600; }
.tw2c-ls a.tw2c-lead:hover{ text-decoration: underline; text-underline-offset: 3px; }
.tw2c-promo{ display: block; margin-top: 24px; }
.tw2c-promo-im{ display: block; aspect-ratio: 4 / 3; overflow: hidden; background: var(--tw2c-imgbg); }
.tw2c-promo-im img{ width: 100%; height: 100%; object-fit: cover; display: block; }
.tw2c-promo--prod .tw2c-promo-im{ background: #fff; }
.tw2c-promo--prod .tw2c-promo-im img{ object-fit: contain; }
.tw2c-promo-nm{ display: block; margin: 8px 0 2px; font-family: var(--font-heading-family); font-weight: 700;
  font-size: 1.6rem; line-height: 1.3; }
.tw2c-promo:hover .tw2c-promo-nm{ color: var(--tw2c-gold); }
.tw2c-split{ display: grid; grid-template-columns: minmax(0, 1fr) 440px; column-gap: 40px; }
.tw2c-groups{ display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 32px 24px; align-content: start; }
.tw2c-h2.tw2c-gh{ margin: 0 0 8px !important; }
.tw2c-gh > a{ display: block; }
.tw2c-gh > a:hover, .tw2c-gh.tw2c-on > a{ color: var(--tw2c-gold); }
.tw2c-side{ min-width: 0; border-left: 1px solid var(--tw2c-line); padding-left: 40px; }
.tw2c-pane[hidden]{ display: none; }
.tw2c-phd{ display: flex; align-items: baseline; justify-content: space-between; gap: 16px; min-height: 24px; margin: 0 0 16px; }
.tw2c-phd .tw2c-h2{ margin: 0 !important; }
.tw2c-pcs{ list-style: none; margin: 0; padding: 0; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 24px 16px; }
.tw2c-pc{ display: block; }
.tw2c-pim{ position: relative; display: block; aspect-ratio: 4 / 3; overflow: hidden; background: var(--tw2c-imgbg); }
.tw2c-pim img{ width: 100%; height: 100%; object-fit: cover; display: block; transition: transform 0.25s ease; }
.tw2c-pc:hover .tw2c-pim img{ transform: scale(1.03); }
.tw2c-pc .tw2c-nm{ margin-top: 8px; min-height: 2.7em; }
.tw2c-pc:hover .tw2c-nm{ color: var(--tw2c-gold); }
.tw2c-new{ position: absolute; left: 8px; top: 8px; z-index: 1; padding: 4px 8px; font-size: 1.1rem; font-weight: 700;
  line-height: 1; background: var(--tw2c-gold); color: rgb(var(--color-button-text)); }
@media (prefers-reduced-motion: reduce){ .tw2c-pim img{ transition: none; } .tw2c-pc:hover .tw2c-pim img{ transform: none; } }
@media screen and (max-width: 1279px){
  .tw2c-split{ grid-template-columns: minmax(0, 1fr) 340px; }
  .tw2c-groups{ grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .tw2c-side{ padding-left: 32px; }
}
`;
document.head.appendChild(TW2_STYLE);
 /* 'current' | 'refix' — see header comment */

var CDN  = 'https://cdn.shopify.com/s/files/1/0641/8048/6344/files/';
var HC   = 'https://cdn.shopify.com/s/files/1/0285/2821/4050/files/';
var COLL = 'https://store.wanderinginn.com/cdn/shop/collections/';

function href(x){ return typeof x === 'string' ? x : (x[PROFILE] || x.current); }

/* ---------------- CONFIG ---------------- */
var WORDMARK = 'https://store.wanderinginn.com/cdn/shop/files/FlatsWithTransperancy.svg?v=1742987591&width=400';

var BOOK_RUNWAY_MS = 21 * 86400000;   /* how early a coming volume takes the card */
var BOOK_GLOW_MS = 14 * 86400000;     /* how long the last volume stays "out now" */

/* A flat runway eats the previous volume's moment when two releases sit close together:
   Fae and Fare (20 Oct) and Immortal Games (10 Nov) are exactly 21 days apart, so a flat
   21-day runway handed the card to Immortal Games the day after Fae and Fare shipped and
   it never once said "out now". Cap each runway at half the gap since the previous
   release, so whatever the schedule, a volume always gets at least half the gap to itself.
   The hero solves the same problem with hand-set per-book leadup days; deriving it here
   keeps the menu correct for volumes nobody has configured yet. */
function bookRunwayMs(books, idx) {
  if (idx <= 0) return BOOK_RUNWAY_MS;
  var gap = (books[idx].epoch - books[idx - 1].epoch) * 1000;
  return Math.min(BOOK_RUNWAY_MS, gap / 2);
}

function twiBookFeature() {
  var fallback = {
    badge: 'In print for the first time',
    meta: 'Book One, Part One · paperback · out 11 August',
    cta: 'Pre-order Book 1',
    ctaHref: '/products/the-wandering-inn'
  };
  var books = (window.TWI_BOOK_RELEASES || []).filter(function (b) { return b && b.epoch; });
  if (!books.length) return fallback;
  books.sort(function (a, b) { return a.epoch - b.epoch; });

  /* ?tpl_date=YYYY-MM-DD previews a future date, same switch the hero honours */
  var qd = new URLSearchParams(location.search).get('tpl_date');
  var now = qd ? new Date(qd + 'T12:00:00Z').getTime() : Date.now();
  var relMs = function (b) { return b.epoch * 1000; };

  var released = books.filter(function (b) { return now >= relMs(b); });
  var upcoming = null, upcomingIdx = -1;
  for (var i = 0; i < books.length; i++) { if (now < relMs(books[i])) { upcoming = books[i]; upcomingIdx = i; break; } }
  var last = released[released.length - 1];

  if (!released.length) {
    return {
      badge: 'In print for the first time',
      meta: books[0].partLabel + ' · paperback · out ' + books[0].dateDisplay,
      cta: 'Pre-order ' + books[0].ctaName, ctaHref: books[0].url, book: books[0]
    };
  }
  if (upcoming && now >= relMs(upcoming) - bookRunwayMs(books, upcomingIdx)) {
    return {
      badge: 'Coming ' + upcoming.dateDisplay,
      meta: upcoming.partLabel + ' · paperback · out ' + upcoming.dateDisplay,
      cta: 'Pre-order ' + upcoming.ctaName, ctaHref: upcoming.url, book: upcoming
    };
  }
  if (upcoming || now < relMs(last) + BOOK_GLOW_MS) {
    return {
      badge: 'Out now',
      meta: last.partLabel + ' · paperback · out now',
      cta: 'Get ' + last.ctaName, ctaHref: last.url, book: last
    };
  }
  return {
    badge: 'The run in print',
    meta: released.length + ' paperbacks · on shelves now',
    cta: 'Shop the books', ctaHref: '/collections/thewanderinginn'
  };
}
var BOOK_FEATURE = twiBookFeature();
/* Shared by the desktop Books featured card and the mobile drawer promo. */
var BOOK_PROMO_IMG = 'https://store.wanderinginn.com/cdn/shop/t/13/assets/book1-art-crop.jpg';

var PAPERBACK_JACKET = {
  'The Wandering Inn': HC + '9780063516380.jpg?width=360',
  'No Killing Goblins': HC + '9780063516403.jpg?width=360',
  'Fae and Fare': HC + '9780063516410_da533879-bc39-4e63-a5c8-964fa9fc2300.jpg?width=360',
  'Immortal Games': HC + '9780063516458.jpg?width=360'
};

var BOOKS = {
  id: 'books', label: 'Books', all: '/collections/bookstore',
  lead: { title: 'The Bookstore', links: [
    { label: 'All Books', href: '/collections/bookstore' },
    { label: 'Reading guide for new readers', href: 'https://wanderinginn.com/new-landing-page/', ext: true },
    { label: 'Audiobooks', href: '/collections/audiobooks' },
    { label: 'Read Free Online', href: 'https://wanderinginn.com' },
    { label: 'Support on Patreon', href: 'https://www.patreon.com/pirateaba' }
  ] },
  depts: [
    {
      featured: true, badge: BOOK_FEATURE.badge,
      title: 'The Wandering Inn',
      meta: BOOK_FEATURE.meta,
      href: '/collections/thewanderinginn', cta: BOOK_FEATURE.cta,
      ctaHref: BOOK_FEATURE.ctaHref,
      img: BOOK_PROMO_IMG,
      links: [
        { label: 'Browse the series', href: '/collections/thewanderinginn' },
        { label: 'Audiobooks', href: '/collections/audiobooks' },
        { label: 'Read free online', href: 'https://wanderinginn.com' }
      ]
    },
    {
      kind: 'Illustrated series', title: 'The Webcomic',
      href: '/collections/the-wandering-inn-web-comic',
      img: COLL + 'mega-menu-146350-twicomicposter2024full-copy025x-1728257180.png?v=1761182812&width=535',
      pos: 'center 12%',
      links: [
        { label: 'Read free online', href: 'https://wanderinginn.com' },
        { label: 'Webcomic merch', href: '/collections/comic-merch' }
      ]
    },
    {
      kind: 'Gravesong series', title: 'The Singer of Terandria',
      href: '/collections/thesingerofterandriaseries',
      img: CDN + 'gravesong-the-wandering-inn-store-pirateaba-4080624.png?width=360',
      pos: 'center 20%',
      /* [2026-08-09] ?fmt=<variant title> carries the format the shopper clicked
         through to the cards, so "E-books" lands on each book's e-book edition
         instead of variant 1. Only `audiobooks` exists as a real format collection;
         every other format entry points at the series collection + ?fmt. Applied by
         sections/main-collection-product-grid.liquid. */
      links: [
        { label: 'E-books', href: '/collections/thesingerofterandriaseries?fmt=E-book' },
        { label: 'Audiobooks', href: '/collections/thesingerofterandriaseries?fmt=Audiobook' }
      ]
    },
    {
      kind: 'Graphic novel', title: 'The Last Tide',
      href: '/collections/the-last-tide-graphic-novel-series',
      img: CDN + 'the-last-tide-the-wandering-inn-store-pirateaba-8654877.jpg?width=360',
      pos: 'center 20%',
      links: [
        { label: 'Softcover', href: '/collections/the-last-tide-graphic-novel-series?fmt=Softcover' },
        { label: 'E-book', href: '/collections/the-last-tide-graphic-novel-series?fmt=E-book' }
      ]
    },
    {
      kind: 'Every volume', title: 'The Bookstore',
      href: '/collections/bookstore',
      img: HC + '9780063516403.jpg?width=360', pos: 'center 25%',
      links: [
        { label: 'All Books', href: '/collections/bookstore' },
        { label: 'Audiobooks', href: '/collections/audiobooks' }
      ]
    }
  ],
  colsRetired: [
    {
      open: true, badge: 'In print for the first time',
      title: 'The Wandering Inn',
      meta: 'Book One, Part One · paperback · out 11 August',
      href: '/products/the-wandering-inn', cta: 'Pre-order now',
      coverImg: HC + '9780063516380.jpg?width=680',
      links: [
        { label: 'Print', href: '/products/the-wandering-inn' },
        { label: 'E-book', href: '/collections/thewanderinginn' },
        { label: 'Audiobook', href: '/collections/audiobooks' },
        { label: 'Read free online', href: 'https://wanderinginn.com' }
      ],
      covers: [
        { t: 'The Wandering Inn (Paperback)', href: '/products/the-wandering-inn', img: HC + '9780063516380.jpg?width=360' },
        { t: 'No Killing Goblins (Paperback)', href: '/collections/thewanderinginn', img: HC + '9780063516403.jpg?width=360' },
        { t: 'Fae and Fare (Paperback)', href: '/collections/thewanderinginn', img: HC + '9780063516410_da533879-bc39-4e63-a5c8-964fa9fc2300.jpg?width=360' },
        { t: 'Immortal Games (Paperback)', href: '/collections/thewanderinginn', img: HC + '9780063516458.jpg?width=360' },
        { t: 'The Wandering Inn', href: '/products/the-wandering-inn', img: CDN + 'the-wandering-inn-the-wandering-inn-store-pirateaba-7462915.png?width=200' },
        { t: 'Blood of Liscor', href: '/products/blood-of-liscor', img: CDN + 'blood-of-liscor-the-wandering-inn-store-pirateaba-8282136.png?width=200' },
        { t: 'Fae and Fare', href: '/products/fae-and-fare', img: CDN + 'fae-and-fare-the-wandering-inn-store-pirateaba-7705302.png?width=200' },
        { t: 'Flowers of Esthelm', href: '/products/flowers-of-esthelm', img: CDN + 'flowers-of-esthelm-the-wandering-inn-store-pirateaba-1016391.png?width=200' },
        { t: 'Garden of Sanctuary', href: '/products/garden-of-sanctuary-1', img: CDN + 'garden-of-sanctuary-the-wandering-inn-store-pirateaba-3886041.png?width=200' },
        { t: "Hell's Wardens", href: '/products/the-empress-of-beasts-copy', img: CDN + 'hells-wardens-the-wandering-inn-store-pirateaba-2829638.png?width=200' },
        { t: 'Tears of Liscor', href: '/products/tears-of-liscor', img: CDN + 'tears-of-liscor-the-wandering-inn-store-pirateaba-1855725.png?width=200' },
        { t: 'The Empress Of Beasts', href: '/products/the-empress-of-beasts', img: CDN + 'the-empress-of-beasts-the-wandering-inn-store-pirateaba-5900022.png?width=200' },
        { t: 'The General of Izril', href: '/products/the-general-of-izril', img: CDN + 'the-general-of-izril-the-wandering-inn-store-pirateaba-1899851.png?width=200' },
        { t: 'The Last Light', href: '/products/the-last-light', img: CDN + 'the-last-light-the-wandering-inn-store-pirateaba-7847073.png?width=200' },
        { t: 'The Rains of Liscor', href: '/products/the-rains-of-liscor', img: CDN + 'the-rains-of-liscor-the-wandering-inn-store-pirateaba-1222414.png?width=200' },
        { t: 'The Titan of Baleros', href: '/products/the-titan-of-baleros', img: CDN + 'the-titan-of-baleros-the-wandering-inn-store-pirateaba-2147897.png?width=200' },
        { t: 'The Wind Runner', href: '/products/the-wind-runner', img: CDN + 'the-wind-runner-the-wandering-inn-store-pirateaba-9653978.png?width=200' },
        { t: 'The Witch Of Webs', href: '/products/the-witch-of-webs', img: CDN + 'the-witch-of-webs-the-wandering-inn-store-pirateaba-8317826.png?width=200' },
        { t: 'Winter Solstice', href: '/products/winter-solstice', img: CDN + 'winter-solstice-the-wandering-inn-store-pirateaba-2658644.png?width=200' }
      ]
    },
    {
      kind: 'Illustrated series', title: 'The Webcomic',
      href: '/collections/the-wandering-inn-web-comic', cta: 'Read the webcomic',
      coverImg: COLL + 'mega-menu-146350-twicomicposter2024full-copy025x-1728257180.png?v=1761182812&width=535',
      links: [
        { label: 'Read free online', href: 'https://wanderinginn.com' },
        { label: 'Support on Patreon', href: 'https://www.patreon.com/pirateaba' }
      ],
      covers: [
        { t: 'The Wandering Inn Webcomic', href: '/collections/the-wandering-inn-web-comic', img: COLL + 'mega-menu-146350-twicomicposter2024full-copy025x-1728257180.png?v=1761182812&width=200' }
      ]
    },
    {
      kind: 'Gravesong series', title: 'The Singer of Terandria',
      href: '/collections/thesingerofterandriaseries', cta: 'Shop the series',
      coverImg: CDN + 'gravesong-the-wandering-inn-store-pirateaba-4080624.png?width=360',
      links: [
        { label: 'E-books', href: '/collections/thesingerofterandriaseries' },
        { label: 'Audiobooks', href: '/collections/thesingerofterandriaseries' }
      ],
      covers: [
        { t: 'Gravesong', href: '/products/gravesong', img: CDN + 'gravesong-the-wandering-inn-store-pirateaba-4080624.png?width=200' },
        { t: 'Ghostsong', href: '/products/ghostsong', img: CDN + 'ghostsong-the-wandering-inn-store-pirateaba-4252083.jpg?width=200' },
        { t: 'Huntsong', href: '/products/huntsong', img: CDN + 'huntsong-the-wandering-inn-store-pirateaba-4113915.png?width=200' }
      ]
    },
    {
      kind: 'Graphic novel', title: 'The Last Tide',
      href: '/collections/the-last-tide-graphic-novel-series', cta: 'Shop the graphic novel',
      coverImg: CDN + 'the-last-tide-the-wandering-inn-store-pirateaba-8654877.jpg?width=360',
      links: [
        { label: 'Softcover', href: '/collections/the-last-tide-graphic-novel-series' },
        { label: 'E-book', href: '/collections/the-last-tide-graphic-novel-series' }
      ],
      covers: [
        { t: 'The Last Tide — Book One', href: '/products/the-last-tide', img: CDN + 'the-last-tide-the-wandering-inn-store-pirateaba-8654877.jpg?width=200' }
      ]
    }
  ]
};

var SHOP = {
  id: 'shop', label: 'Merch', all: '/collections/all-products',
  lead: { title: 'All Products', links: [
    { label: 'New Arrivals', href: '/collections/new-arrivals' },
    { label: 'Best Sellers', href: '/collections/best-sellers' },
    { label: 'On Sale', href: '/collections/on-sale' },
    { label: 'Bundles', href: '/collections/bundles' },
    { label: 'Best for Gifting', href: '/collections/best-for-gifting' },
    { label: 'Gift Cards', href: '/collections/gift-cards' }
  ] },
  /* calm pass: spotlight card removed */
  depts: [
    { title: 'Apparel', href: '/collections/all-apparel',
      img: COLL + 'hoodies-and-sweatshirts-5232258.jpg?v=1759689714&width=360',
      links: [
        { label: 'T-shirts & Tops', href: '/collections/t-shirts' },
        { label: 'Hoodies & Sweatshirts', href: '/collections/hoodies-and-sweatshirts' },
        { label: 'Knitwear', href: { current: '/collections/knitwear', refix: '/collections/hoodies-and-sweatshirts' } },
        { label: 'Hats & Beanies', href: '/collections/headwear' },
        { label: 'Pants & Sportswear', href: '/collections/all-apparel' },
        { label: "Women's Fit", href: { current: '/collections/womens-fit', refix: '/collections/all-apparel' } }
      ]},
    { title: 'Collectibles', href: { current: '/collections/plushies', refix: '/collections/collectibles' },
      featured: true, cta: 'Shop collectibles',
      ctaHref: { current: '/collections/plushies', refix: '/collections/collectibles' },
      img: COLL + 'mrsha-the-great-and-terribly-adorable-plush-the-wandering-inn-store-pirateaba-3790643.jpg?v=1761182222&width=600',
      links: [
        { label: 'Plushies', href: '/collections/plushies' },
        { label: "Erin's Frying Pan", href: '/products/erins-frying-pan' },
        { label: "The [Innkeeper]'s Collection", href: '/collections/the-innkeepers-collection' },
        { label: 'Handmade Mug', href: '/products/the-wandering-inn-handmade-mug' },
        { label: 'Graphic Tee', href: '/products/local-landmark-graphic-tee' },
        { label: 'Aprons', href: '/collections/aprons' }
      ]},
    { title: 'Posters & Art', href: { current: '/collections/posters-and-art', refix: '/collections/posters-and-art' },
      img: COLL + 'art-prints-6391038.jpg?v=1759689703&width=360',
      links: [
        { label: 'Posters', href: { current: '/collections/posters', refix: '/collections/posters-and-art' } },
        { label: 'Art Prints', href: '/collections/art-prints' },
        { label: 'Maps', href: '/collections/maps' },
        /* [2026-09-02] Puzzles -> Games & Puzzles: the refix href pointed at the
           parent (dead link); games-and-puzzles is the new tag-driven collection. */
        { label: 'Games & Puzzles', href: '/collections/games-and-puzzles' },
        { label: 'Wall Art', href: '/collections/wall-art' }
      ]},
    { title: 'Homewares', href: { current: '/collections/home-and-office', refix: '/collections/homewares' },
      img: COLL + 'drinkware-2506434.jpg?v=1759689708&width=360',
      links: [
        { label: 'Mugs & Drinkware', href: '/collections/drinkware' },
        { label: 'Cookware', href: '/collections/cookware' },
        { label: 'Pillows & Blankets', href: { current: '/collections/blankets-and-throws', refix: '/collections/cosy' } },
        { label: 'Desk & Office', href: { current: '/collections/home-and-office', refix: '/collections/desk-and-office' } },
        /* [2026-08-23] Stationery sits directly beside Desk & Office rather than
           getting its own dept card: /collections/stationery currently holds a
           single product (the Logo hardcover bound notebook), which is a link,
           not a shelf. Promote it to a sixth dept once it carries a real range.
           Handle verified live 200; the old /collections/stationary 301s to it,
           so the misspelling is already redirected on this store. */
        { label: 'Stationery', href: '/collections/stationery' },
        { label: 'Holiday & Seasonal', href: '/collections/holiday-and-seasonal' }
      ],
      },
    { title: 'Accessories', href: '/collections/all-accessories',
      img: COLL + 'pins-3356145.jpg?v=1759689747&width=360',
      links: [
        { label: 'Enamel Pins', href: '/collections/pins' },
        { label: 'Patches', href: '/collections/patches' },
        { label: 'Keychains', href: '/collections/keychains' },
        { label: 'Phone Cases', href: { current: '/collections/phone-cases', refix: '/collections/tech-accessories' } },
        { label: 'Stickers & Tattoos', href: '/collections/stickers' },
        { label: 'Bags & Totes', href: { current: '/collections/all-accessories', refix: '/collections/bags-and-totes' } },
        /* [2026-09-02] Travel: passport cover, umbrella, duffel, travel mug (tag cat:travel). */
        { label: 'Travel', href: '/collections/travel' }
      ]}
  ]
};

function tw2Esc(s){
  return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
    .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
/* https URLs and same-site paths only. Protocol-relative Shopify CDN URLs
   ("//store.wanderinginn.com/cdn/...", what image_url returns) resolve to
   https. Anything else (javascript:, data:, http:) is dropped, which removes
   that link or image rather than rendering it. */
function tw2SafeUrl(u){
  if (typeof u !== 'string') return '';
  u = u.trim();
  if (!u) return '';
  try {
    var p = new URL(u, document.baseURI);
    return p.protocol === 'https:' ? p.href : '';
  } catch (e) { return ''; }
}
function tw2Str(v){ return typeof v === 'string' ? v.trim() : ''; }
function tw2Items(arr, max){
  return (Array.isArray(arr) ? arr : []).map(function(p){
    if (!p || typeof p !== 'object') return null;
    var u = tw2SafeUrl(p.url), t = tw2Str(p.title);
    var rating = Number(p.rating), reviews = Number(p.reviews);
    return (u && t) ? { title: t, url: u, price: tw2Str(p.price), compare: tw2Str(p.compare), label: tw2Str(p.label),
      img: tw2SafeUrl(p.img),
      /* [2026-09-26] published date (YYYY-MM-DD), for the Merch "New" label */
      added: (typeof p.added === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(p.added)) ? p.added : '',
      /* Judge.me stars, only when the product has reviews */
      rating: (reviews > 0 && rating > 0 && rating <= 5) ? rating : 0, reviews: reviews > 0 ? Math.floor(reviews) : 0 } : null;
  }).filter(Boolean).slice(0, max);
}

var LOOKBOOK_FILES = 'https://store.wanderinginn.com/cdn/shop/files/';
var FEATURE_FALLBACK = {
  handle: 'fallback', kind: 'default', layout: 'lookbook', navLabel: '',
  title: "The [Innkeeper]'s Collection", eyebrow: 'The lookbook',
  blurb: 'A limited-edition collection made with Aleksandar Mitrovic.',
  href: '/collections/the-innkeepers-collection', cta: 'Shop the collection',
  lookbook: '/pages/lookbook-innkeepers-collection',
  /* the three lead photos of the live lookbook page, same as the mockup */
  images: [
    LOOKBOOK_FILES + 'DSCF72211_c01bb11c-7597-4fdd-8936-377c72f089d9.png?v=1740026998&width=900',
    LOOKBOOK_FILES + 'DSCF7341_1_19326bd4-5886-4b59-8adc-9b637e9e9bc1.jpg?v=1729426751&width=600',
    LOOKBOOK_FILES + 'DSCF6732_1.png?v=1729433012&width=600'
  ],
  /* no products in the fallback: they would be hand-picked and go stale */
  pieces: []
};

function tw2Count(v){ var n = Number(v); return (isFinite(n) && n > 0) ? Math.floor(n) : 0; }
function tw2CleanFeature(r){
  if (!r || typeof r !== 'object') return null;
  var title = tw2Str(r.title), link = tw2SafeUrl(r.href);
  if (!title || !link) return null;
  return {
    handle: tw2Str(r.handle), kind: tw2Str(r.kind) || 'season',
    layout: r.layout === 'gift_finder' ? 'gift_finder' : 'lookbook',
    navLabel: tw2Str(r.navLabel).slice(0, 24),
    title: title, eyebrow: tw2Str(r.eyebrow), blurb: tw2Str(r.blurb),
    href: link, cta: tw2Str(r.cta) || (r.layout === 'gift_finder' ? 'Shop gifts' : 'Shop the collection'),
    lookbook: tw2SafeUrl(r.lookbook),
    images: (Array.isArray(r.images) ? r.images : []).map(tw2SafeUrl).filter(Boolean).slice(0, 3),
    /* product photos (white backgrounds) are shown whole, lookbook photos fill the box */
    photoFit: r.photoFit === 'contain' ? 'contain' : 'cover',
    count: tw2Count(r.count),
    pieces: tw2Items(r.pieces, 3)
  };
}
function tw2GiftLabel(t){
  var s = tw2Str(t).replace(/^gifts?\s+(from\s+)?/i, '');
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : tw2Str(t);
}
function tw2CleanGift(g){
  if (!g || typeof g !== 'object') return null;
  var bands = (Array.isArray(g.bands) ? g.bands : []).map(function(b){
    if (!b || typeof b !== 'object') return null;
    var h = tw2SafeUrl(b.href), l = tw2GiftLabel(b.label);
    return (h && l) ? { label: l, href: h, count: tw2Count(b.count), items: tw2Items(b.items, 4) } : null;
  }).filter(Boolean);
  var link = function(o){ return (o && typeof o === 'object' && tw2SafeUrl(o.href)) ? tw2SafeUrl(o.href) : ''; };
  return {
    bands: bands,
    giftCards: link(g.giftCards) ? { href: link(g.giftCards), img: tw2SafeUrl(g.giftCards.img), from: tw2Str(g.giftCards.from) } : null,
    bundles: link(g.bundles) ? { href: link(g.bundles), items: tw2Items(g.bundles.items, 2) } : null,
    best: link(g.best) ? { href: link(g.best), count: tw2Count(g.best.count) } : null
  };
}
var MENU_PICKED = window.TWI_MENU_PICKED || {};
var MENU_FEATURE = tw2CleanFeature(MENU_PICKED.entry) || FEATURE_FALLBACK;
var MENU_GIFT = MENU_FEATURE.layout === 'gift_finder' ? tw2CleanGift(MENU_PICKED.gift) : null;
/* no button text set: "Shop all 11" when the count is known (mockup wording) */
if (MENU_FEATURE.layout === 'lookbook' && !tw2Str((MENU_PICKED.entry || {}).cta) && MENU_FEATURE.count) MENU_FEATURE.cta = 'Shop all ' + MENU_FEATURE.count;
/* gift finder with no gift data at all (no gift collections yet): lookbook of the fallback */
if (MENU_FEATURE.layout === 'gift_finder' && !(MENU_GIFT && MENU_GIFT.bands.length)) { MENU_FEATURE = FEATURE_FALLBACK; MENU_GIFT = null; }
/* for QA in the console: which entry won, and for what date */
window.TWI_MENU_FEATURE = { date: MENU_PICKED.date || '', handle: MENU_FEATURE.handle, title: MENU_FEATURE.title, layout: MENU_FEATURE.layout };

function tw2Path(u){ try { return new URL(u, document.baseURI).pathname.replace(/\/+$/, ''); } catch (e) { return ''; } }

/* Collection tiles under the lookbook (mockup order). The featured collection
   is left out of its own tiles, so when Halloween takes the slot The
   [Innkeeper]'s Collection moves down into the tiles instead of vanishing.
   These are links to collections, not products, so nothing here goes stale. */
var COLL_TILES = [
  { title: "The [Innkeeper]'s Collection", href: '/collections/the-innkeepers-collection',
    img: COLL + 'the-innkeepers-collection-6636269.jpg?v=1759689757&width=400' },
  { title: 'Horns of Hammerad', href: '/collections/horns-of-hammerad',
    img: COLL + 'horns-of-hammerad-collection-1592613.png?v=1759689722&width=400' },
  { title: 'Wistram Academy', href: '/collections/wistram',
    img: COLL + 'wistram-earther-hoodie-the-wandering-inn-store-pirateaba-6264487.png?v=1760927769&width=400' },
  { title: 'The Employee Uniform', href: '/collections/employee-uniform',
    img: COLL + 'erins-frying-pan-the-wandering-inn-store-pirateaba-5656880.png?v=1761182652&width=400' },
  { title: 'Gravesong Concert Merch', href: '/collections/gravesong',
    img: COLL + 'gravesong-2519017.jpg?v=1759689710&width=400' },
  { title: 'Logo Collection', href: '/collections/logo-collection',
    img: COLL + 'comic-logo-t-shirt-unisex-the-wandering-inn-store-pirateaba-5679458.png?v=1760931951&width=400' },
  { title: 'Runners Guild', href: '/collections/runners-guild',
    img: COLL + 'runners-guild-8038983.png?v=1759689670&width=400' }
];
function tw2CollTitle(t){ return tw2Str(String(t || '').replace(/ /g, ' ')).replace(/ - /g, ': '); }
var COLL_RAIL = (Array.isArray(MENU_PICKED.collections) ? MENU_PICKED.collections : []).map(function(c){
  if (!c || typeof c !== 'object') return null;
  var h = tw2SafeUrl(c.href), t = tw2CollTitle(c.title);
  return (h && t) ? { title: t, href: h, img: tw2SafeUrl(c.img), count: tw2Count(c.count) } : null;
}).filter(Boolean);
if (!COLL_RAIL.length) COLL_RAIL = COLL_TILES.slice(0, 7).map(function(t){ return { title: t.title, href: t.href, img: t.img.replace('width=400', 'width=120'), count: 0 }; });
var FEATURE_PATH = tw2Path(MENU_FEATURE.href);

/* the mobile drawer's featured card. Gift finder: its links are the gift
   columns, so every column is one tap away on a phone too. */
var FEATURE_DEPT = { title: MENU_FEATURE.title, href: MENU_FEATURE.href, featured: true,
  img: MENU_FEATURE.images[0] || (MENU_GIFT && MENU_GIFT.bands[0] && MENU_GIFT.bands[0].items[0] && MENU_GIFT.bands[0].items[0].img) || '',
  /* [2026-09-25 16:10] no eyebrows in the polished design, so only the short line */
  meta: MENU_FEATURE.blurb, cta: MENU_FEATURE.cta,
  links: MENU_GIFT
    ? MENU_GIFT.bands.map(function(b){ return { label: b.label, href: b.href }; })
        .concat(MENU_GIFT.bundles ? [{ label: 'Bundles', href: MENU_GIFT.bundles.href }] : [])
        .concat(MENU_GIFT.giftCards ? [{ label: 'Gift cards', href: MENU_GIFT.giftCards.href }] : [])
        .concat(MENU_GIFT.best ? [{ label: 'Best for gifting', href: MENU_GIFT.best.href }] : [])
    : (MENU_FEATURE.lookbook ? [{ label: 'View the lookbook', href: MENU_FEATURE.lookbook }] : []) };

var COLLECTIONS = {
  id: 'collections',
  /* nav_label: the same text snippets/twi-mega-nav.liquid put in the desktop
     trigger before paint; the drawer uses it for its row and back button */
  label: MENU_FEATURE.navLabel || 'Collections',
  all: '/collections', allLabel: 'View all collections',
  /* desktop: the strip along the bottom; mobile: the quick-link chips */
  lead: { title: 'More Collections', links: [
    { label: 'Holiday & Seasonal', href: '/collections/holiday-and-seasonal' },
    { label: 'On Sale', href: '/collections/on-sale' }
  ] },
  feature: MENU_FEATURE, gift: MENU_GIFT, rail: COLL_RAIL,
  /* mobile drawer: the feature card, then the same list minus the featured collection */
  depts: [FEATURE_DEPT].concat(COLL_RAIL.filter(function(t){ return tw2Path(t.href) !== FEATURE_PATH; })
    .map(function(t){ return { title: t.title, href: t.href, img: t.img, meta: t.count ? t.count + (t.count === 1 ? ' item' : ' items') : '', links: [] }; }))
};

function tw2Link(l){
  if (!l || typeof l !== 'object') return null;
  var h = tw2SafeUrl(l.href), t = tw2Str(l.title);
  return (h && t) ? { label: t, href: h, lead: l.lead === true } : null;
}
function tw2CleanMerch(m){
  if (!m || typeof m !== 'object') return null;
  var shop = (Array.isArray(m.shop) ? m.shop : []).map(tw2Link).filter(Boolean).slice(0, 12);
  var groups = (Array.isArray(m.groups) ? m.groups : []).map(function(g){
    if (!g || typeof g !== 'object') return null;
    var h = tw2SafeUrl(g.href), t = tw2Str(g.title);
    return (h && t) ? { title: t, href: h, count: tw2Count(g.count), img: tw2SafeUrl(g.img),
      links: (Array.isArray(g.links) ? g.links : []).map(tw2Link).filter(Boolean).slice(0, 10),
      items: tw2Items(g.items, 4) } : null;
  }).filter(Boolean).slice(0, 8);
  if (!shop.length || !groups.length) return null;
  var b = m.best;
  var best = (b && typeof b === 'object' && tw2SafeUrl(b.href))
    ? { title: tw2Str(b.title), href: tw2SafeUrl(b.href), img: tw2SafeUrl(b.img), items: tw2Items(b.items, 4) } : null;
  var lead = shop.filter(function(l){ return l.lead; })[0] || null;
  return { shop: shop, groups: groups, best: best, lead: lead,
    all: (m.all && typeof m.all === 'object') ? tw2SafeUrl(m.all.href) : '' };
}
/* "New": published within 60 days before the visitor's date (the preview date with ?menu_date) */
var TW2_TODAY = Date.parse((MENU_PICKED.date || '') + 'T12:00:00Z');
function tw2IsNew(p){
  if (!p.added || !isFinite(TW2_TODAY)) return false;
  var d = (TW2_TODAY - Date.parse(p.added + 'T12:00:00Z')) / 864e5;
  return d >= 0 && d <= 60;
}
/* the seasonal tile: today's menu_feature entry (the one the Collections panel shows), or, on the
   default entry, the Best sellers tile. Reuses the entry's own title, link and collection. */
function tw2MerchPromo(mm){
  var raw = MENU_PICKED.entry, f = tw2CleanFeature(raw);
  if (f && raw && tw2Str(raw.kind) !== 'default') {
    return { title: f.title, href: f.href,
      img: f.images[0] || tw2SafeUrl(raw.tile) || (f.pieces[0] && f.pieces[0].img) || '',
      fit: f.images[0] ? f.photoFit : 'cover',
      cta: f.count ? 'Shop all ' + f.count : (tw2Str(raw.cta) || 'Shop now'), key: f.handle || 'season' };
  }
  if (!mm.best) return null;
  var t = (mm.lead && mm.lead.label) || mm.best.title || 'Best sellers';
  return { title: t, href: mm.best.href, img: mm.best.img || (mm.best.items[0] && mm.best.items[0].img) || '',
    fit: 'cover', cta: 'Shop ' + t.toLowerCase(), key: 'default' };
}
var MERCH = tw2CleanMerch(MENU_PICKED.merch);
if (Array.isArray(MENU_PICKED.flags) && MENU_PICKED.flags.length) {
  try { console.warn('[twi-mega] admin menu missing or empty, built-in list in use: ' + MENU_PICKED.flags.join(', ')); } catch (e) {}
}
if (MERCH) {
  MERCH.promo = tw2MerchPromo(MERCH);
  SHOP = {
    id: 'shop', label: 'Merch', all: MERCH.all || SHOP.all, allLabel: 'View all merch',
    merch: MERCH,
    /* mobile drawer: the Shop links as chips (lead first-class), the seasonal tile as the featured
       card, then one row per type group with its sub-links, same order as desktop */
    lead: { title: 'Shop', links: MERCH.shop },
    depts: (MERCH.promo ? [{ title: MERCH.promo.title, href: MERCH.promo.href, img: MERCH.promo.img, featured: true,
        meta: '', cta: MERCH.promo.cta, links: [] }] : [])
      .concat(MERCH.groups.map(function(g){ return { title: g.title, href: g.href, img: g.img,
        meta: g.count ? g.count + (g.count === 1 ? ' item' : ' items') : '', links: g.links }; }))
  };
}
window.TWI_MENU_FEATURE && (window.TWI_MENU_FEATURE.merch = MERCH ? { promo: MERCH.promo && MERCH.promo.key, groups: MERCH.groups.length } : null);

var MENUS = [BOOKS, SHOP, COLLECTIONS];
var CART_COUNT = (window.Shopify && window.Shopify.cart_count) || document.querySelector('.cart-count-bubble span[aria-hidden]')?.textContent?.trim() || '';

/* ---------------- helpers ---------------- */
function h(html){ var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstChild; }
/* [2026-09-17 a11y] Every panel group needs a stable, unique id so its section
   can name itself with aria-labelledby. The sheets are built once at load, so
   a simple counter is enough — ids never have to survive a re-render. */
var TW2_UID = 0;
function tw2id(){ return 'tw2-h' + (++TW2_UID); }
var CARET = '<svg class="tw2-caret" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6"><path d="m2 4 4 4 4-4"/></svg>';
var CHEV  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m6 9 6 6 6-6"/></svg>';

function spotHtml(s){
  if (!s) return '';
  return '<div class="tw2-spot">' +
    '<a class="tw2-spot-media" href="' + href(s.href) + '" tabindex="-1" aria-hidden="true"><img src="' + s.img + '" alt="" loading="lazy"></a>' +
    '<span class="tw2-eyebrow">' + s.eyebrow + '</span>' +
    '<a class="tw2-spot-name" href="' + href(s.href) + '">' + s.title + '</a>' +
    (s.price ? '<span class="tw2-spot-price">' + s.price + '</span>' : '') +
    '<a class="tw2-btn" href="' + href(s.href) + '">' + s.ctaLabel + '</a>' +
  '</div>';
}
function leadHtml(lead, spot){
  /* [2026-09-17 a11y] was a bare <div> — the quick-links column had no
     accessible name, so its links joined the panel's one long flat run. */
  var lid = tw2id();
  return '<section class="tw2-lead" aria-labelledby="' + lid + '">' +
    /* [2026-09-18 a11y] an h3, not a span, so all ten panel sections are
       named by a heading (styled to match the old span, see .tw2-lead h3). */
    '<h3 class="tw2-eyebrow" id="' + lid + '">' + lead.title + '</h3>' +
    /* [2026-08-15] `ext: true` on a lead link opens it in a new tab. rel is
       noopener+noreferrer, not just target - without noopener the opened page
       gets a window.opener handle back into this one (reverse tabnabbing). */
    lead.links.map(function(l){
      var ext = l.ext ? ' target="_blank" rel="noopener noreferrer"' : '';
      return '<a href="' + href(l.href) + '"' + ext + '>' + l.label + '</a>';
    }).join('') +
    (lead.cta ? '<a class="tw2-btn tw2-btn--outline tw2-lead-cta" href="' + href(lead.cta.href) + '">' + lead.cta.label + '</a>' : '') +
    spotHtml(spot) +
  '</section>';
}
function kickerHtml(d){
  if (d.badge) return '<div class="tw2-kicker"><span class="tw2-badge">' + d.badge + '</span></div>';
  if (d.kind)  return '<div class="tw2-kicker"><span class="tw2-eyebrow">' + d.kind + '</span></div>';
  return '<div class="tw2-kicker"></div>';
}
function deptHtml(d){
  /* [2026-09-17 a11y] The <section> had no accessible name and the title was a
     plain <a>, so a screen reader met each panel as one undifferentiated run of
     20-40 links. Naming the section (aria-labelledby) and promoting the title to
     a real heading gives both region and heading navigation. The heading carries
     the SAME .tw2-title class the anchor used to, so the rendering is unchanged
     (see the .tw2-title rule for the h3 defaults it has to neutralise). */
  var tid = tw2id();
  return '<section class="tw2-dept' + (d.featured ? ' tw2-dept--featured' : '') + '" aria-labelledby="' + tid + '">' +
    '<a class="tw2-dept-media" href="' + href(d.href) + '" tabindex="-1" aria-hidden="true"><img src="' + d.img + '" alt="" loading="lazy"' +
      (d.pos ? ' style="object-position:' + d.pos + '"' : '') + '></a>' +
    kickerHtml(d) +
    '<h3 class="tw2-title" id="' + tid + '"><a href="' + href(d.href) + '">' + d.title + '</a></h3>' +
    (d.meta ? '<p class="tw2-meta">' + d.meta + '</p>' : '') +
    (d.links.length ? '<ul class="tw2-links">' + d.links.map(function(l){
      return '<li><a href="' + href(l.href) + '">' + l.label + '</a></li>'; }).join('') + '</ul>' : '') +
    (d.thumbs ? '<div class="tw2-thumbs"><span class="tw2-eyebrow">Popular</span><div class="tw2-thumbs-row">' +
      d.thumbs.map(function(t){ return '<a href="' + href(t.href) + '" title="' + t.t + '"><img src="' + t.img + '" alt="' + t.t + '" loading="lazy"></a>'; }).join('') +
      '</div></div>' : '') +
    (d.cta || d.cta2
      ? '<div class="tw2-ctas">' +
          (d.cta ? '<a class="tw2-btn" href="' + href(d.ctaHref || d.href) + '">' + d.cta + '</a>' : '') +
          (d.cta2 ? '<a class="tw2-btn tw2-btn--outline" href="' + href(d.cta2href) + '">' + d.cta2 + '</a>' : '') +
        '</div>'
      : '') +
  '</section>';
}
function deptsSheet(menu){
  var cols = menu.depts.map(function(d){ return (d.featured ? '1.45' : '1') + 'fr'; }).join(' ');
  return '<div class="tw2-flex">' + leadHtml(menu.lead, menu.spot) +
    '<div class="tw2-depts" style="grid-template-columns:' + cols + '">' +
      menu.depts.map(deptHtml).join('') + '</div></div>';
}

function posterSheet(menu){
  var feat = menu.depts.filter(function(d){ return d.featured; })[0];
  var rest = menu.depts.filter(function(d){ return !d.featured; });
  return '<div class="tw2-flex">' + leadHtml(menu.lead, menu.spot) +
    '<div class="tw2-depts" style="grid-template-columns:1.35fr 2fr">' +
      deptHtml(feat) +
      '<div class="tw2-postgrid" style="padding:0">' +
        rest.map(function(d){
          return '<div class="tw2-postcard">' +
            '<a class="tw2-postbg" href="' + href(d.href) + '" aria-label="' + d.title + '">' +
              '<img src="' + d.img + '" alt="" loading="lazy"' + (d.pos ? ' style="object-position:' + d.pos + '"' : '') + '></a>' +
            /* [2026-09-17 a11y] heading, not a bare link — same reason as
               deptHtml above; .tw2-posttitle neutralises the h3 defaults. The
               foot is a <div> now because a <span> may not contain a heading. */
            '<div class="tw2-postfoot">' +
              '<h3 class="tw2-posttitle"><a href="' + href(d.href) + '">' + d.title + '</a></h3>' +
              (d.links && d.links.length
                ? '<span class="tw2-postlinks">' + d.links.map(function(l){
                    return '<a href="' + href(l.href) + '">' + l.label + '</a>'; }).join('') + '</span>'
                : '') +
            '</div>' +
          '</div>';
        }).join('') +
      '</div>' +
    '</div></div>';
}
function tw2Stars(p){
  if (!p.rating || !p.reviews) return '';
  var n = p.reviews, r = p.rating;
  return '<span class="tw2c-rt" aria-label="Rated ' + r.toFixed(2) + ' out of 5 from ' + n + ' review' + (n === 1 ? '' : 's') + '">' +
    '<span class="tw2c-st" aria-hidden="true">&#9733;</span> ' + r.toFixed(1) + ' (' + n + ')</span>';
}
/* mini row: 56px square thumb, name (2 lines max), price + stars */
function tw2Mrow(p, metaHtml){
  var e = tw2Esc;
  return '<li><a class="tw2c-mr" href="' + e(p.url) + '">' +
    '<span class="tw2c-th">' + (p.img ? '<img src="' + e(p.img) + '" alt="" loading="lazy" decoding="async" width="56" height="56">' : '') + '</span>' +
    '<span class="tw2c-tx"><span class="tw2c-nm">' + (p.label ? e(p.label) + ': ' : '') + e(p.title) + '</span>' +
      (metaHtml != null ? metaHtml :
        '<span class="tw2c-ml">' + (p.price ? '<span>' + e(p.price) + (p.compare ? ' <s>' + e(p.compare) + '</s>' : '') + '</span>' : '') + tw2Stars(p) + '</span>') +
    '</span></a></li>';
}
/* rail row: 40px thumb, name, "N items" (the left-column collection list) */
function tw2Rrow(c){
  var e = tw2Esc;
  return '<li><a class="tw2c-rr" href="' + e(c.href) + '">' +
    '<span class="tw2c-ld">' + (c.img ? '<img src="' + e(c.img) + '" alt="" loading="lazy" decoding="async" width="40" height="40">' : '') + '</span>' +
    '<span class="tw2c-tx"><span class="tw2c-nm">' + e(c.title) + '</span>' +
      (c.count ? '<span class="tw2c-meta">' + c.count + (c.count === 1 ? ' item' : ' items') + '</span>' : '') + '</span></a></li>';
}
function tw2Heads(){
  if (!TW2_ASSETS) return '';
  return '<ul class="tw2c-heads" role="list" aria-label="Shop by character">' + TW2_HEADS.map(function(c){
    return '<li><a href="' + tw2Esc(href('/collections/' + c[0])) + '" title="' + tw2Esc(c[1]) + '">' +
      '<img src="' + tw2Esc(TW2_ASSETS + 'twi-headshot-' + c[2] + '.webp') + '" alt="' + tw2Esc(c[1]) + '" loading="lazy" decoding="async" width="40" height="40"></a></li>';
  }).join('') + '</ul>';
}
function tw2More(label, url){
  return '<a class="tw2c-more" href="' + tw2Esc(url) + '">' + tw2Esc(label) + ' <span aria-hidden="true">&rarr;</span></a>';
}
function tw2Lookbook(f){
  var e = tw2Esc, imgs = f.images || [], fit = f.photoFit === 'contain' ? ' tw2c-lb--prod' : '';
  var to = f.lookbook || f.href;
  var photo = function(src, cls, w, hgt){
    /* the photos repeat the title link, so they stay out of the tab order */
    return '<a class="tw2c-lb' + cls + fit + '" href="' + e(to) + '" tabindex="-1" aria-hidden="true">' +
      '<img src="' + e(src) + '" alt="" loading="lazy" decoding="async" width="' + w + '" height="' + hgt + '"></a>';
  };
  var n = Math.min(imgs.length, 3);
  var photos = (n >= 1 ? photo(imgs[0], ' tw2c-lb--big', 900, 1050) : '') +
    (n >= 2 ? '<div class="tw2c-lbs">' + photo(imgs[1], '', 600, 700) + (n >= 3 ? photo(imgs[2], '', 600, 700) : '') + '</div>' : '');
  var tid = tw2id();
  var ctas = f.lookbook
    ? '<a class="tw2c-bt tw2c-bt--pri" href="' + e(f.lookbook) + '">View the lookbook</a>' +
      '<a class="tw2c-bt" href="' + e(f.href) + '">' + e(f.cta) + '</a>'
    : '<a class="tw2c-bt tw2c-bt--pri" href="' + e(f.href) + '">' + e(f.cta) + '</a>';
  return '<div class="tw2c-feat tw2c-feat--' + n + '">' + photos +
    '<section class="tw2c-ftx" aria-labelledby="' + tid + '">' +
      '<h3 class="tw2c-h1" id="' + tid + '"><a href="' + e(f.href) + '">' + e(f.title) + '</a></h3>' +
      (f.blurb ? '<p class="tw2c-lede">' + e(f.blurb) + '</p>' : '') +
      '<div class="tw2c-ctas">' + ctas + '</div>' +
      (f.pieces.length ? '<ul class="tw2c-mrs" role="list">' + f.pieces.map(function(p){ return tw2Mrow(p); }).join('') + '</ul>' : '') +
    '</section></div>';
}
function tw2Gifts(g){
  var e = tw2Esc;
  var col = function(title, rows, foot){
    var hid = tw2id();
    return '<section class="tw2c-gcol" aria-labelledby="' + hid + '"><h3 class="tw2c-h2" id="' + hid + '">' + e(title) + '</h3>' +
      (rows ? '<ul class="tw2c-mrl" role="list">' + rows + '</ul>' : '') + foot + '</section>';
  };
  var html = g.bands.map(function(b){
    return col(b.label, b.items.map(function(p){ return tw2Mrow(p); }).join(''),
      tw2More(b.count ? 'Shop all ' + b.count : 'Shop all', b.href));
  }).join('');
  var easy = '';
  if (g.giftCards) easy += tw2Mrow({ url: g.giftCards.href, img: g.giftCards.img, title: 'Gift card', label: '' },
    g.giftCards.from ? '<span class="tw2c-ml"><span>From ' + e(g.giftCards.from) + '</span></span>' : '');
  if (g.bundles) easy += g.bundles.items.map(function(p){ return tw2Mrow({ url: p.url, img: p.img, title: p.title, price: p.price,
    compare: p.compare, rating: p.rating, reviews: p.reviews, label: '' }); }).join('');
  if (easy || g.best) html += col('Easy gifts', easy,
    g.best ? tw2More('Best for gifting' + (g.best.count ? ' (' + g.best.count + ')' : ''), g.best.href) : '');
  var cols = g.bands.length + ((easy || g.best) ? 1 : 0);
  return '<div class="tw2c-g" style="grid-template-columns:repeat(' + cols + ',minmax(0,1fr))">' + html + '</div>';
}
function collSheet(menu){
  var hid = tw2id();
  return '<div class="tw2c" data-tw2-feature="' + tw2Esc(menu.feature.handle || menu.feature.kind) + '">' +
    '<div class="tw2c-pg">' +
      '<section class="tw2c-col1" aria-labelledby="' + hid + '"><h3 class="tw2c-h2 tw2c-hd" id="' + hid + '">Collections</h3>' +
        '<ul class="tw2c-rail" role="list">' + menu.rail.map(tw2Rrow).join('') + '</ul>' + tw2Heads() + '</section>' +
      '<div class="tw2c-col2">' + (menu.gift ? tw2Gifts(menu.gift) : tw2Lookbook(menu.feature)) + '</div>' +
    '</div>' +
    '<div class="tw2c-strip">' + tw2More('All collections', href(menu.all)) + '</div>' +
  '</div>';
}
function tw2Card(p){
  var e = tw2Esc;
  return '<li><a class="tw2c-pc" href="' + e(p.url) + '">' +
    '<span class="tw2c-pim">' + (tw2IsNew(p) ? '<span class="tw2c-new">New</span>' : '') +
      (p.img ? '<img src="' + e(p.img) + '" alt="" loading="lazy" decoding="async" width="480" height="360">' : '') + '</span>' +
    '<span class="tw2c-nm">' + e(p.title) + '</span>' +
    '<span class="tw2c-ml">' + (p.price ? '<span>' + e(p.price) + (p.compare ? ' <s>' + e(p.compare) + '</s>' : '') + '</span>' : '') + tw2Stars(p) + '</span>' +
  '</a></li>';
}
function merchSheet(menu){
  var mm = menu.merch, e = tw2Esc, panes = '', pid = {};
  var pane = function(id, title, moreLabel, moreHref, items, on){
    var hid = tw2id();
    return '<section class="tw2c-pane" id="' + id + '" aria-labelledby="' + hid + '"' + (on ? '' : ' hidden') + '>' +
      '<div class="tw2c-phd"><h3 class="tw2c-h2" id="' + hid + '">' + e(title) + '</h3>' + tw2More(moreLabel, moreHref) + '</div>' +
      (items.length ? '<ul class="tw2c-pcs" role="list">' + items.map(tw2Card).join('') + '</ul>' : '') + '</section>';
  };
  var bestId = mm.best ? tw2id() + '-p' : '';
  if (mm.best) panes += pane(bestId, (mm.lead && mm.lead.label) || mm.best.title, 'Shop all', mm.best.href, mm.best.items, true);
  var groups = mm.groups.map(function(g, i){
    var id = tw2id() + '-p';
    panes += pane(id, g.title, g.count ? 'Shop all ' + g.count : 'Shop all', g.href, g.items, !mm.best && i === 0);
    return '<div class="tw2c-grp"><h3 class="tw2c-h2 tw2c-gh' + (!mm.best && i === 0 ? ' tw2c-on' : '') + '"><a href="' + e(g.href) + '" data-tw2-pane="' + id + '">' + e(g.title) + '</a></h3>' +
      (g.links.length ? '<ul class="tw2c-ls tw2c-ls--muted" role="list">' + g.links.map(function(l){
        return '<li><a href="' + e(l.href) + '">' + e(l.label) + '</a></li>'; }).join('') + '</ul>' : '') + '</div>';
  }).join('');
  var shop = mm.shop.map(function(l){
    return '<li><a href="' + e(l.href) + '"' + (l.lead ? ' class="tw2c-lead"' + (bestId ? ' data-tw2-pane="' + bestId + '"' : '') : '') + '>' + e(l.label) + '</a></li>';
  }).join('');
  var p = mm.promo;
  var promo = p ? '<a class="tw2c-promo' + (p.fit === 'contain' ? ' tw2c-promo--prod' : '') + '" href="' + e(p.href) + '" data-tw2-season="' + e(p.key) + '">' +
      '<span class="tw2c-promo-im">' + (p.img ? '<img src="' + e(p.img) + '" alt="" loading="lazy" decoding="async" width="480" height="360">' : '') + '</span>' +
      '<span class="tw2c-promo-nm">' + e(p.title) + '</span>' +
      '<span class="tw2c-more">' + e(p.cta) + ' <span aria-hidden="true">&rarr;</span></span></a>' : '';
  var sid = tw2id();
  return '<div class="tw2c tw2c-merch" data-tw2-default="' + (bestId || '') + '">' +
    '<div class="tw2c-pg">' +
      '<section class="tw2c-col1" aria-labelledby="' + sid + '"><h3 class="tw2c-h2 tw2c-hd" id="' + sid + '">Shop</h3>' +
        '<ul class="tw2c-ls" role="list">' + shop + '</ul>' + promo + '</section>' +
      '<div class="tw2c-col2"><div class="tw2c-split">' +
        '<div class="tw2c-groups">' + groups + '</div>' +
        '<div class="tw2c-side">' + panes + '</div>' +
      '</div></div>' +
    '</div>' +
    '<div class="tw2c-strip">' + tw2More('All merch', mm.all || href(menu.all)) + '</div>' +
  '</div>';
}
function bookColHtml(c){
  return '<section class="tw2-bkcol' + (c.open ? ' tw2-open' : '') + '">' +
    '<a class="tw2-tile" href="' + href(c.href) + '">' +
      '<img src="' + c.coverImg + '" alt="" loading="lazy">' +
      '<span class="tw2-tile-name">' + c.title + '</span>' +
    '</a>' +
    '<div class="tw2-bkx">' +
      '<a class="tw2-bkx-cover" href="' + href(c.href) + '" tabindex="-1" aria-hidden="true"><img src="' + c.coverImg + '" alt="" loading="lazy"></a>' +
      '<div class="tw2-bkx-body">' +
        kickerHtml(c) +
        '<a class="tw2-title" href="' + href(c.href) + '">' + c.title + '</a>' +
        (c.meta ? '<p class="tw2-meta">' + c.meta + '</p>' : '') +
        '<ul class="tw2-links">' + c.links.map(function(l){
          return '<li><a href="' + href(l.href) + '">' + l.label + '</a></li>'; }).join('') + '</ul>' +
        (c.cta ? '<a class="tw2-btn" href="' + href(c.href) + '">' + c.cta + '</a>' : '') +
      '</div>' +
    '</div>' +
  '</section>';
}
function bandPaneHtml(c, i){
  if (!c.covers || !c.covers.length) return '';
  return '<div class="tw2-band-pane' + (c.open ? ' tw2-active' : '') + '" data-band="' + i + '">' +
    '<span class="tw2-eyebrow">' + c.title + ' — in this series</span>' +
    '<div class="tw2-band-row">' + c.covers.map(function(cv){
      return '<a href="' + href(cv.href) + '" title="' + cv.t + '"><img src="' + cv.img + '" alt="' + cv.t + '" loading="lazy"></a>'; }).join('') +
    '</div>' +
    '<button class="tw2-band-arrow tw2-band-arrow--prev" type="button" aria-label="Scroll back"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m15 6-6 6 6 6"/></svg></button>' +
    '<button class="tw2-band-arrow tw2-band-arrow--next" type="button" aria-label="Scroll forward"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 6 6 6-6 6"/></svg></button>' +
  '</div>';
}
function booksSheet(menu){
  return '<div class="tw2-flex">' + leadHtml(menu.lead, menu.spot) +
    '<div class="tw2-bkwrap">' +
      '<div class="tw2-bkcols">' + menu.cols.map(bookColHtml).join('') + '</div>' +
      '<div class="tw2-band">' + menu.cols.map(bandPaneHtml).join('') + '</div>' +
    '</div></div>';
}

/* ---------------- mount desktop ---------------- */
var headerEl = document.querySelector('.header');
var wrapperEl = document.querySelector('.header-wrapper');
if (!headerEl || !wrapperEl) return;

/* logo: set NATIVELY via theme settings since 2026-08-09 (settings_data.json
   logo -> FlatsWithTransperancy.svg) - the JS swap that lived here caused an
   emblem->wordmark flash on every load. WORDMARK below is still used by the
   mobile drawer head. */

var SHEET_HTML = {
  books: posterSheet(BOOKS),
  shop: SHOP.merch ? merchSheet(SHOP) : deptsSheet(SHOP),
  collections: collSheet(COLLECTIONS)   /* [2026-09-25 16:10] polished layout; see collSheet */
};
var mountedAny = false;
MENUS.forEach(function(m){
  var panel = document.getElementById('tw2-sheet-' + m.id);
  if (!panel || panel.getAttribute('data-tw2-filled')) return;
  panel.innerHTML = SHEET_HTML[m.id];
  panel.setAttribute('data-tw2-filled', '1');
  mountedAny = true;
});
if (!mountedAny) return;
/* [2026-09-25] keep the desktop trigger text in line with the panel (the head
   script set it pre-paint; this only differs if the gift data was missing and
   the panel fell back to the default) */
(function(){ var l = document.getElementById('tw2-label-collections');
  if (l && l.textContent !== COLLECTIONS.label) l.textContent = COLLECTIONS.label; })();

(function wireMerchPanes(){
  var sheet = document.getElementById('tw2-sheet-shop');
  var root = sheet && sheet.querySelector('.tw2c-merch');
  if (!root) return;
  var trig = Array.prototype.slice.call(root.querySelectorAll('[data-tw2-pane]'));
  var panes = Array.prototype.slice.call(root.querySelectorAll('.tw2c-pane'));
  var timer = null, def = root.getAttribute('data-tw2-default') || (panes[0] && panes[0].id) || '';
  function act(id){
    if (!id) return;
    panes.forEach(function(p){ p.hidden = p.id !== id; });
    trig.forEach(function(a){ var hh = a.closest('.tw2c-gh'); if (hh) hh.classList.toggle('tw2c-on', a.getAttribute('data-tw2-pane') === id); });
  }
  trig.forEach(function(a){
    var id = a.getAttribute('data-tw2-pane');
    a.addEventListener('mouseenter', function(){ clearTimeout(timer); timer = setTimeout(function(){ act(id); }, 140); });
    a.addEventListener('mouseleave', function(){ clearTimeout(timer); });
    a.addEventListener('focus', function(){ clearTimeout(timer); act(id); });
  });
  var d = document.getElementById('Details-HeaderMenu-tw2-shop');
  if (d) d.addEventListener('toggle', function(){ if (!d.open) { clearTimeout(timer); act(def); } });
})();

var hoverOpen, hoverClose;
var hoverOpened = {};
var hoverMq = window.matchMedia('(hover: hover) and (min-width: 990px)');
function det(id){ return document.getElementById('Details-HeaderMenu-tw2-' + id); }
function btn(id){ return document.getElementById('tw2-btn-' + id); }

function openDetails(id){
  MENUS.forEach(function(o){
    var d = det(o.id); if (!d) return;
    if (o.id === id){ if (!d.open){ d.setAttribute('open',''); } }
    else if (d.open){ d.removeAttribute('open'); }
    var sm = btn(o.id); if (sm) sm.setAttribute('aria-expanded', String(o.id === id));
  });
}
function closeAll(){
  MENUS.forEach(function(o){
    var d = det(o.id); if (d && d.open) d.removeAttribute('open');
    var sm = btn(o.id); if (sm) sm.setAttribute('aria-expanded', 'false');
  });
}
function anyOpenId(){
  for (var i = 0; i < MENUS.length; i++){ var d = det(MENUS[i].id); if (d && d.open) return MENUS[i].id; }
  return null;
}

MENUS.forEach(function(m){
  var d = det(m.id); if (!d) return;
  var li = d.closest('li');

  /* keep aria-expanded truthful however Dawn opened it (click, Enter, Space) */
  d.addEventListener('toggle', function(){
    if (!d.open) hoverOpened[m.id] = false;
    var sm = btn(m.id); if (sm) sm.setAttribute('aria-expanded', String(d.open));
    if (d.open) MENUS.forEach(function(o){
      if (o.id === m.id) return;
      var od = det(o.id);
      if (od && od.open){ od.removeAttribute('open'); var os = btn(o.id); if (os) os.setAttribute('aria-expanded','false'); }
    });
  });

  /* Hover is an ACCELERATOR over the click-capable native base, never the only
     way in. Delays follow the research rather than feel: 300ms before opening
     (Baymard: instant-open menus "flicker" on pass-through; 300-500ms is the
     intent threshold — this was 60ms) and 500ms before closing (NN/g: tolerates
     imprecise pointer travel and the diagonal move into the panel). */
  li.addEventListener('mouseenter', function(){
    if (!hoverMq.matches) return;
    clearTimeout(hoverClose);
    hoverOpen = setTimeout(function(){ var dd = det(m.id); if (dd && !dd.open) hoverOpened[m.id] = true; openDetails(m.id); }, 300);
  });
  var sumEl = d.querySelector('summary');
  if (sumEl) sumEl.addEventListener('click', function(e){
    clearTimeout(hoverOpen);
    if (d.open && hoverOpened[m.id]) { e.preventDefault(); hoverOpened[m.id] = false; }
  });
  li.addEventListener('mouseleave', function(){
    clearTimeout(hoverOpen);
    if (!hoverMq.matches) return;
    hoverClose = setTimeout(function(){ var d2 = det(m.id); if (d2 && d2.open) closeAll(); }, 500);
  });
});

/* Current-scope highlighting. Nothing in the header used to show which
   section you were in — Baymard's 2025 benchmark puts that failure at 95% of
   sites and NN/g calls it "probably the single most common mistake" in
   navigation. Mark the top-level item whose panel contains the current URL,
   using Dawn's own .header__active-menu-item so it looks native, plus
   aria-current="page" on the exact link for screen readers. */
(function markCurrentScope(){
  var here = location.pathname.replace(/\/+$/, '');
  if (!here) return;

  function pathOf(a){
    try { return new URL(a.href, location.origin).pathname.replace(/\/+$/, ''); }
    catch (e) { return ''; }
  }

  /* Exactly ONE section may be marked. Pass 1 looks for a link that IS this
     page; only if nothing matches does pass 2 fall back to the section's own
     landing path. The first version skipped the single-match rule and used a
     bare prefix test, so /collections (the Collections landing) prefixed every
     collection page and two items underlined at once. */
  var winner = null, currentLink = null;

  MENUS.forEach(function(m){
    if (winner) return;
    var panel = document.getElementById('tw2-sheet-' + m.id);
    if (!panel) return;
    var links = panel.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++){
      if (pathOf(links[i]) === here){ winner = m; currentLink = links[i]; return; }
    }
  });

  if (!winner){
    MENUS.forEach(function(m){
      if (winner || !m.all) return;
      var allPath = href(m.all).replace(/\/+$/, '');
      /* '/collections' is every collection page's prefix — never a scope signal */
      if (!allPath || allPath === '/collections') return;
      if (here === allPath || here.indexOf(allPath + '/') === 0) winner = m;
    });
  }

  if (!winner) return;
  if (currentLink) currentLink.setAttribute('aria-current', 'page');
  var summary = btn(winner.id);
  if (summary) summary.setAttribute('data-tw2-current', 'true');
})();

/* WCAG 1.4.13 Dismissible: Escape closes without moving the pointer, and
   returns focus to the trigger (Dawn's DetailsDisclosure does not do this). */
document.addEventListener('keydown', function(e){
  if (e.key !== 'Escape') return;
  var id = anyOpenId(); if (!id) return;
  clearTimeout(hoverOpen); clearTimeout(hoverClose);
  closeAll();
  var sm = btn(id); if (sm) sm.focus();
});

/* Books expansion + band retired with the bento pass (git history has it). */

/* ---------------- mobile: burger + drawer ---------------- */
var MOBILE_V3 = true;

function mountNativeMobileMenu(MENUS, href) {
  var host = document.querySelector('header-drawer');
  if (!host) return false;
  var nativeNav = host.querySelector('.menu-drawer__navigation');
  if (!nativeNav) return false;

  /* Our content lives in its own container beside Dawn's, and Dawn's own
     configured links are hidden — the theme's menu setting stays intact and
     reversible in admin. Dawn's drawer shell (hamburger, slide, focus trap,
     scroll lock) still drives everything because we keep its classes and
     reuse its own submenu handlers. */
  var ownNav = host.querySelector('.tw2m-nav');
  if (!ownNav) {
    ownNav = document.createElement('nav');
    ownNav.className = 'menu-drawer__navigation tw2m-nav';
    /* [2026-09-17 a11y] This landmark replaces Dawn's own drawer nav, so it
       needs the same accessible name Dawn's carries. */
    ownNav.setAttribute('aria-label', (nativeNav.getAttribute('aria-label') || 'Menu'));
    ownNav.innerHTML = '<ul class="menu-drawer__menu has-submenu list-menu" role="list"></ul>';
    nativeNav.insertAdjacentElement('afterend', ownNav);
  }
  var list = ownNav.querySelector('.menu-drawer__menu');
  if (!list) return false;

  var ARROW = '<svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></svg>';
  var CARET = '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg>';

  var ITEM = 'menu-drawer__menu-item list-menu__item link link--text focus-inset';

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

  /* thumbnail + label row — the only departure from stock Dawn markup, and it
     rides inside the native item so native padding/hover/active still apply */
  function face(d) {
    return (d.img ? '<span class="tw2m-thumb"><img src="' + d.img + '" alt="" loading="lazy"' +
             (d.pos ? ' style="object-position:' + d.pos + '"' : '') + '></span>' : '') +
      '<span class="tw2m-face"><span class="tw2m-label">' + esc(d.title) + '</span>' +
      (d.meta ? '<span class="tw2m-meta">' + esc(d.meta) + '</span>' : '') + '</span>';
  }

  /* L3: a department's own collections, as a native sub-submenu */
  function deptWithChildren(m, d) {
    var id = slug(m.id + '-' + d.title);
    return '<li><details id="Details-menu-drawer-' + id + '">' +
      '<summary class="' + ITEM + ' tw2m-row" id="HeaderDrawer-' + id + '">' +
        face(d) + ARROW + CARET +
      '</summary>' +
      '<div id="childlink-' + id + '" class="menu-drawer__submenu has-submenu gradient motion-reduce">' +
        '<button class="menu-drawer__close-button link link--text focus-inset" aria-expanded="true">' +
          ARROW + esc(d.title) +
        '</button>' +
        '<ul class="menu-drawer__menu list-menu" role="list" tabindex="-1">' +
          '<li><a href="' + href(d.href) + '" class="' + ITEM + ' tw2m-all">Shop all ' + esc(d.title) + '</a></li>' +
          d.links.map(function (l) {
            return '<li><a href="' + href(l.href) + '" class="' + ITEM + '">' + esc(l.label) + '</a></li>';
          }).join('') +
        '</ul>' +
      '</div></details></li>';
  }

  /* a department with no children is just a link row */
  function deptLeaf(d) {
    return '<li><a href="' + href(d.href) + '" class="' + ITEM + ' tw2m-row">' + face(d) + '</a></li>';
  }

  /* L2: one top-level menu's submenu panel */
  function menuPanel(m) {
    var feat = m.depts.filter(function (d) { return d.featured; })[0];
    var rest = m.depts.filter(function (d) { return !d.featured; });

    var featHtml = feat ? '<li class="tw2m-feat-li"><a class="tw2m-feat" href="' + href(feat.href) + '">' +
      /* [2026-09-25] no image span when the feature has no image (a menu_feature
         entry with no photos and an image-less collection) - no broken <img> */
      (feat.img ? '<span class="tw2m-feat-img"><img src="' + feat.img + '" alt="" loading="lazy"' +
        (feat.pos ? ' style="object-position:' + feat.pos + '"' : '') + '></span>' : '') +
      '<span class="tw2m-feat-body">' +
        (feat.badge ? '<span class="tw2m-badge">' + esc(feat.badge) + '</span>' : '') +
        '<span class="tw2m-feat-title">' + esc(feat.title) + '</span>' +
        (feat.meta ? '<span class="tw2m-feat-meta">' + esc(feat.meta) + '</span>' : '') +
        (feat.cta ? '<span class="tw2m-feat-cta">' + esc(feat.cta) + '</span>' : '') +
      '</span></a></li>' : '';

    /* the featured item's own links still need to be reachable */
    var featLinks = (feat && feat.links && feat.links.length)
      ? '<li class="tw2m-featlinks"><ul class="tw2m-chiplist">' + feat.links.map(function (l) {
          return '<li><a href="' + href(l.href) + '">' + esc(l.label) + '</a></li>';
        }).join('') + '</ul></li>'
      : '';

    /* shortcuts ride at the TOP, not the bottom: Best Sellers / New Arrivals
       are among the strongest links in the menu and were previously buried
       under the fold (and colliding with the drawer's footer). */
    /* Baymard: only 24% of sites put a "View All <category>" row at each mobile
       level; bare headings read as informational and never get tapped. */
    var viewAll = m.all
      ? '<li><a href="' + href(m.all) + '" class="' + ITEM + ' tw2m-all">' + (m.allLabel ? esc(m.allLabel) : 'View all ' + esc(m.label)) + '</a></li>'
      : '';

    var quick = m.lead && m.lead.links && m.lead.links.length
      ? '<li class="tw2m-quick"><span class="tw2m-eyebrow">' + esc(m.lead.title) + '</span>' +
          '<ul class="tw2m-chiplist">' + m.lead.links.map(function (l) {
            var ext = l.ext ? ' target="_blank" rel="noopener noreferrer"' : '';
            /* [2026-09-26] the Merch lead link (Best sellers) is gold here too, as on desktop */
            return '<li><a href="' + href(l.href) + '"' + ext + (l.lead ? ' class="tw2m-lead"' : '') + '>' + esc(l.label) + '</a></li>';
          }).join('') + '</ul></li>'
      : '';

    return viewAll + quick + featHtml + featLinks +
      rest.map(function (d) {
        return (d.links && d.links.length) ? deptWithChildren(m, d) : deptLeaf(d);
      }).join('') +
      '<li class="tw2m-tailpad" aria-hidden="true"></li>';
  }

  /* L1: the drawer root */
  var html = MENUS.map(function (m) {
    return '<li><details id="Details-menu-drawer-' + m.id + '">' +
      '<summary class="' + ITEM + ' tw2m-top" id="HeaderDrawer-' + m.id + '">' +
        esc(m.label) + ARROW + CARET +
      '</summary>' +
      '<div id="link-' + m.id + '" class="menu-drawer__submenu has-submenu gradient motion-reduce" tabindex="-1">' +
        '<div class="menu-drawer__inner-submenu">' +
          '<button class="menu-drawer__close-button link link--text focus-inset" aria-expanded="true">' +
            ARROW + esc(m.label) +
          '</button>' +
          '<ul class="menu-drawer__menu list-menu" role="list" tabindex="-1">' + menuPanel(m) + '</ul>' +
        '</div>' +
      '</div></details></li>';
  }).join('');

  var pBook = BOOK_FEATURE.book;
  var pImg  = (pBook && pBook.paperbackImg) ||
              (pBook && PAPERBACK_JACKET[pBook.title]) || BOOK_PROMO_IMG;
  var pTitle = (pBook && pBook.title) || 'The Wandering Inn';
  var pTerr = '';
  if (pBook && pBook.ukEpoch && Date.now() < pBook.ukEpoch * 1000) pTerr = ' · US/CA';
  /* shortRef is "Book 1 Part 1" - published by the releases snippet precisely
     for consumers that want the exact volume. */
  var pVol = (pBook && pBook.shortRef) ? pBook.shortRef + ' · Paperback' : 'Paperback';
  /* CTA carries no book name: BOOK_FEATURE.cta is "Get Book 1", which would
     repeat pVol. Verb only, still phase-correct. */
  var pCta = /Pre-order/i.test(BOOK_FEATURE.cta || '') ? 'Pre-order now' : 'Shop now';
  html += '<li><a href="https://www.patreon.com/pirateaba" class="' + ITEM + ' tw2m-top">Support on Patreon</a></li>' +
          '<li class="tw2m-promo-li"><a class="tw2m-feat" href="' + href(BOOK_FEATURE.ctaHref) + '">' +
            '<span class="tw2m-feat-img"><img src="' + pImg + '" alt="" loading="lazy"></span>' +
            '<span class="tw2m-feat-body">' +
              '<span class="tw2m-badge">' + esc(BOOK_FEATURE.badge + pTerr) + '</span>' +
              '<span class="tw2m-feat-title">' + esc(pTitle) + '</span>' +
              '<span class="tw2m-feat-meta">' + esc(pVol) + '</span>' +
              '<span class="tw2m-feat-cta">' + esc(pCta) + '</span>' +
            '</span></a></li>';

  list.innerHTML = html;

  /* [2026-09-17 a11y] Dawn's ARIA pass over `[id^="Details-"] summary`
     (assets/global.js, module scope) runs at parse time, long before this nav
     is injected — so every sub-menu trigger in here shipped with no
     role="button", no aria-expanded and no aria-controls, and a screen reader
     announced them as inert text. Repeat that pass over what we injected.
     Dawn deliberately skips its keyup-Escape binding inside header-drawer
     (the drawer has its own), so we skip it too. */
  list.querySelectorAll('[id^="Details-"] summary').forEach(function (summary) {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
    var panel = summary.nextElementSibling;
    if (panel && panel.getAttribute('id')) summary.setAttribute('aria-controls', panel.id);
    summary.addEventListener('click', function (event) {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });
  });

  /* Dawn bound its listeners in the constructor, so injected summaries are
     dead. Do NOT call host.bindEvents() — it re-binds the main hamburger too,
     which then toggles twice per tap (drawer opens and instantly shuts).
     Bind only what we injected; the main summary lives outside `list`. */
  if (typeof host.onSummaryClick === 'function') {
    list.querySelectorAll('summary').forEach(function (s) {
      s.addEventListener('click', host.onSummaryClick.bind(host));
    });
  }
  if (typeof host.onCloseButtonClick === 'function') {
    list.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', host.onCloseButtonClick.bind(host));
    });
  }

  /* The drawer's utility links (log in / country / socials) are position:
     relative with z-index 1002, so they paint OVER the bottom of any submenu
     panel. Panels are fixed-height, so the covered rows are simply
     unreachable. Measure that strip and reserve it as scrollable padding —
     measured, not hardcoded, because its height changes with which of
     account / localisation / social is enabled. */
  function addSupportToUtility() {
    var util = host.querySelector('.menu-drawer__utility-links');
    if (!util || util.querySelector('.tw2m-util-support')) return;
    var acct = util.querySelector('.menu-drawer__account');
    var a = document.createElement('a');
    a.href = href('/pages/support');
    a.className = 'menu-drawer__account link focus-inset h5 tw2m-util-support';
    a.textContent = 'Customer Support';
    if (acct && acct.parentNode === util) util.insertBefore(a, acct.nextSibling);
    else util.insertBefore(a, util.firstChild);
  }
  addSupportToUtility();

  function reserveUtilitySpace() {
    var util = host.querySelector('.menu-drawer__utility-links');
    var hgt = util ? util.offsetHeight : 0;
    if (hgt > 0) ownNav.style.setProperty('--tw2m-utilh', hgt + 'px');
  }
  reserveUtilitySpace();
  var mainSummary = host.querySelector('summary.header__icon--menu');
  if (mainSummary) mainSummary.addEventListener('click', function () {
    setTimeout(reserveUtilitySpace, 60);
  });
  window.addEventListener('resize', reserveUtilitySpace);

  document.documentElement.classList.add('tw2m-native');
  return true;
}

/* --- styles: additive only, riding on Dawn's drawer tokens --------------- */
var TW2M_CSS = `
/* hide Dawn's own configured drawer links; ours sit directly after them */
html.tw2m-native .menu-drawer__navigation:not(.tw2m-nav){ display:none !important; }



.tw2m-row{ display:flex !important; align-items:center; gap:1.2rem; }
.tw2m-thumb{ flex:0 0 auto; width:4.4rem; height:4.4rem; border-radius:var(--tw2-radius, 0.6rem);
  overflow:hidden; background:rgba(var(--color-foreground),0.06); }
.tw2m-thumb img{ width:100%; height:100%; object-fit:cover; display:block; }
.tw2m-face{ display:flex; flex-direction:column; gap:0.2rem; min-width:0; }
.tw2m-label{ display:block; }
.tw2m-meta{ font-size:1.2rem; opacity:0.62; }
.tw2m-all{ font-weight:600; }

.tw2m-feat-li{ padding:0 0 0.6rem; }
.tw2m-feat{ display:flex; gap:1.4rem; align-items:stretch; text-decoration:none; color:inherit;
  padding:1.2rem 2rem; }
.tw2m-feat-img{ flex:0 0 auto; width:9.6rem; height:9.6rem; border-radius:var(--tw2-radius, 0.6rem);
  overflow:hidden; background:rgba(var(--color-foreground),0.06); }
.tw2m-feat-img img{ width:100%; height:100%; object-fit:cover; display:block; }
.tw2m-feat-body{ display:flex; flex-direction:column; justify-content:center; gap:0.4rem; min-width:0; }
.tw2m-badge{ align-self:flex-start; font-size:1.05rem; letter-spacing:0.1em; text-transform:uppercase;
  padding:0.3rem 0.7rem; border-radius:0.4rem; background:rgb(var(--color-button));
  color:rgb(var(--color-button-text)); font-weight:600; }
.tw2m-feat-title{ font-size:1.7rem; font-weight:600; line-height:1.2; }
.tw2m-feat-meta{ font-size:1.25rem; opacity:0.66; line-height:1.35; }
.tw2m-feat-cta{ margin-top:0.4rem; font-size:1.3rem; font-weight:600; color:rgb(var(--color-button)); }

.tw2m-featlinks{ padding:0 2rem 1.2rem; }
.tw2m-chiplist{ list-style:none; margin:0; padding:0; display:flex; flex-wrap:wrap; gap:0.6rem; }
.tw2m-chiplist a{ display:inline-block; padding:0.5rem 1rem; border-radius:100px; text-decoration:none;
  font-size:1.25rem; color:rgb(var(--color-foreground));
  border:0.1rem solid rgba(var(--color-foreground),0.18); }

.tw2m-chiplist a.tw2m-lead{ color:rgb(var(--color-button)); border-color:rgba(var(--color-button),0.6); font-weight:600; }
.tw2m-quick{ padding:1.2rem 2rem 1.4rem;
  border-bottom:0.1rem solid rgba(var(--color-foreground),0.12); }
.tw2m-eyebrow{ display:block; font-size:1.1rem; letter-spacing:0.14em; text-transform:uppercase;
  opacity:0.55; margin-bottom:0.9rem; }

/* Dawn only sets overflow-y:auto on NESTED submenus — its own first-level
   panels are short lists that never overflow. Ours are longer (hero + chips +
   departments), so they need to scroll, and every panel needs the bottom
   strip reserved (see reserveUtilitySpace: the utility links overlay it). */
html.tw2m-native .tw2m-nav .menu-drawer__submenu{
  overflow-y:auto; -webkit-overflow-scrolling:touch; }
/* End the FIRST-LEVEL panel above the utility strip rather than padding it:
   padding only makes the panel scrollable, it doesn't stop the bottom rows
   rendering underneath the overlay at rest. Nested panels inherit this bound
   (their containing block is the first-level panel), so scope it to level 1. */
html.tw2m-native .tw2m-nav > .menu-drawer__menu > li > details > .menu-drawer__submenu{
  bottom:var(--tw2m-utilh, 17.5rem); }
html.tw2m-native .tw2m-nav .menu-drawer__submenu > .menu-drawer__inner-submenu,
html.tw2m-native .tw2m-nav .menu-drawer__submenu > .menu-drawer__menu{
  padding-bottom:2rem; }
.tw2m-tailpad{ display:none; }

/* [2026-08-15] Root-level promo + the lone utility link under it. The card
   borrows .tw2m-feat*, so all that is needed here is the separation. */
.tw2m-promo-li{ margin-top:0.6rem; padding-top:0.6rem;
  border-top:0.1rem solid rgba(var(--color-foreground),0.12); }
.tw2m-util{ margin-top:0.4rem;
  border-top:0.1rem solid rgba(var(--color-foreground),0.12); }

/* The promo shows a book JACKET, so it must not be cropped square like the
   scene-art cards — portrait box + contain, and no grey plate behind it. */
/* SQUARE, not portrait. The 3D renders are 300x300 with the book composed
   inside, so a portrait box letterboxed them down to a thumbnail. Keeping the
   shared 9.6rem square and only dropping the grey plate lets the render fill
   the space. Still object-fit contain, so the book is never cropped.
   NB: no backticks in this block - TW2M_CSS is a JS template literal and a
   backtick here ends the string (caught by the pre-deploy parse check). */
.tw2m-promo-li .tw2m-feat-img{ background:none; }
.tw2m-promo-li .tw2m-feat-img img{ object-fit:contain; }
/* Needs the parent in the selector. This link deliberately carries Dawn's
   .menu-drawer__account class to inherit its type + icon spacing, but that
   class also sets display:inline-flex — and component-menu-drawer.css is
   <link>ed from inside sections/header.liquid, i.e. in the BODY, so it lands
   AFTER this runtime-injected <style> in document order and wins every tie.
   (0,2,0) beats it outright, which is why "Customer Support" was rendering on
   the same line as "Log in". */
.menu-drawer__utility-links .tw2m-util-support{ display:flex; width:100%; margin-top:1rem; }
`;

if (MOBILE_V3) {
  var tw2mStyle = document.createElement('style');
  tw2mStyle.textContent = TW2M_CSS;
  document.head.appendChild(tw2mStyle);
  mountNativeMobileMenu(MENUS, href);
}

window.addEventListener('resize', function(){
  if (window.innerWidth < 990 && anyOpenId()) closeAll();
});
})();
